import React, { useState, useEffect, Fragment, InputHTMLAttributes, forwardRef, useCallback, useMemo } from 'react';
import { Button, Row, Col, Card, CardBody, InputGroup, Input, Nav, UncontrolledTooltip, Modal, ModalHeader, ModalFooter, ModalBody, Label, Table } from 'reactstrap';
import { ChevronLeft, ChevronRight, Download, Edit, Eye, File, FileText, LogIn, RotateCcw, Trash2 } from 'react-feather';
import DataTable from 'react-data-table-component';
import webservice from '../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import 'flatpickr/dist/themes/material_blue.css'; // Import the CSS for the theme you want to use
import { Link, useNavigate, useParams } from 'react-router-dom';
import { saveAs } from 'file-saver'
import { useAppDispatch } from '../../../ReaduxToolkit/Hooks';
import { useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { getPatientData, Get_permission } from './store';
import Swal from 'sweetalert2';
import axios from 'axios';
import moment from 'moment';
import websocket_webservice from '../../../Service/websocket_webservice'
import ExcelJS from 'exceljs';
import regenrate from '../../../assets/Avatar/regenrate.svg'
import portaldownload from '../../../assets/Avatar/pdf.svg'
import api from '../../../api';

interface JsonData {
    field: string;
    value?: any;
    before?: any;
    after?: any;
}

interface AuditData {
    Modified: string;
    Action: string;
    JsonData: JsonData[];
    UserName: string;
}

const getAuditFieldRank = (key: string): number => {
    const normalized = key.trim().toLowerCase().replace(/[\s_\/-]+/g, "");

    // 1. First Name
    if (["firstname"].includes(normalized)) return 1;
    // 2. Last Name
    if (["lastname"].includes(normalized)) return 2;
    // 3. Patient DOB
    if (["patientdob", "dob", "dateofbirth"].includes(normalized)) return 3;
    // 4. Member ID
    if (["memberid", "memberidentification"].includes(normalized)) return 4;
    // 5. Provider or Company name
    if (["providerorcompanyname", "providercompanyname"].includes(normalized)) return 5;
    // 6. Provider / Group NPI
    if (["providergroupnpi", "providernpi", "groupnpi", "providerid"].includes(normalized)) return 6;
    // 7. Provider Tax Id
    if (["providertaxid", "providertin"].includes(normalized)) return 7;
    // 8. City
    if (["city"].includes(normalized)) return 8;
    // 9. State
    if (["state"].includes(normalized)) return 9;
    // 10. Zip Code
    if (["zipcode", "zip", "postalcode"].includes(normalized)) return 10;
    // 11. Facility
    if (["facility"].includes(normalized)) return 11;
    // 12. Patient Type
    if (["patienttype", "type"].includes(normalized)) return 12;
    // 13. Subscriber First Name
    if (["subscriberfirstname"].includes(normalized)) return 13;
    // 14. Subscriber Last Name
    if (["subscriberlastname"].includes(normalized)) return 14;
    // 15. Subscriber DOB
    if (["subscriberdob", "subscriberpatientdob", "subscriberdateofbirth"].includes(normalized)) return 15;
    // 16. Subscriber Member Id
    if (["subscribermemberid"].includes(normalized)) return 16;
    // 17. Insurance Network
    if (["insurancenetwork"].includes(normalized)) return 17;
    // 18. Fee Schedule
    if (["feeschedule"].includes(normalized)) return 18;

    // Special: Insurance Name (placed at the end)
    if (["insurancename", "payername", "insurance", "payer"].includes(normalized)) return 2000;
    // Special: Screenshot Status (placed at the end)
    if (["screenshotstatus"].includes(normalized)) return 2001;

    return 1000;
};
interface DeleteRowData {
    Patientname: string;
    id: string;
    PatientDOB: string;
    Memberid: string;
    CompanyName: string;
    uploaded_date: string;
    RefId: string;
    Payor_ID: string;
    Provider_NPI: string;
    Payer_ID: string;
    Provider_Name: string;
    Provider_ID: string;
    template_mapping_time: string;
    xml_conversion_time: string;
    template_creation: string;
    DataMapping: string;
    execution_time: string;
    Payer_Name: string;
    Data_Fetched: string;
    xml_conversion: string;
    error_message: string;
    error_reason: string;
    onederfulId: string;
    UserName: string;
    Type: string;
    Payer_name: string;
    Regenratedpatient: string;
    bot_status?: string;
    RPA_Status?: string;
}

type PatientData = {
    First_Name: string;
    MiddleName: string;
    Last_Name: string;
    Memberid: string;
    Type: string;
    PatientDOB: string;
    Provider_ID: string;
    Payer_name: string;
    Regenratedpatient: string;
    RefId: string;
};


const CustomHeader = ({ value, handleFilter, handlePerPage, rowsPerPage }: any) => {
    return (
        <div className='client-master-list-table-header w-100 py-2'>
            <Row>
                <Col lg='4' className='d-flex align-items-center px-0 px-lg-1'>
                    <div className='d-flex align-items-center me-4 '>
                        <label htmlFor='rows-per-page' className='me-2'>Rows per Page:</label>
                        <Input
                            type='select'
                            id='rows-per-page'
                            value={rowsPerPage}
                            onChange={handlePerPage}
                            className='form-control ms-50 larger-select '
                        >
                            <option value='10'>10</option>
                            <option value='25'>25</option>
                            <option value='50'>50</option>
                        </Input>
                    </div>
                    <Button tag={Link} to={'/BulkUpload'} color='secondary' style={{ marginLeft: "2%" }} >
                        Back
                    </Button>
                </Col>
                {/* Color Indicator Legend */}
                <Col lg='4' className='d-flex align-items-center px-0 px-lg-1'>
                    <div style={{
                        marginTop: '20px',
                        padding: '10px 2%',
                        display: 'flex',
                        gap: '30px',
                        alignItems: 'center',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: 'rgba(34, 223, 16, 1)',
                                borderRadius: '3px'
                            }}></div>
                            <span style={{ fontSize: '14px', fontWeight: '500' }}>Completed</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: '#f54552',
                                borderRadius: '3px'
                            }}></div>
                            <span style={{ fontSize: '14px', fontWeight: '500' }}>Error</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: '#800080',
                                borderRadius: '3px'
                            }}></div>
                            <span style={{ fontSize: '14px', fontWeight: '500' }}>In Progress</span>
                        </div>
                    </div>
                </Col>
                <Col
                    lg='4'
                    className='d-flex align-items-center justify-content-lg-end mt-lg-0 mt-1 px-0 px-lg-3'
                >
                    <InputGroup className="input-group-search mb-2 zoom-on-hover">
                        <Input
                            type="text"
                            placeholder="🔍 Search...."
                            value={value}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="input-search"
                        />
                    </InputGroup>
                </Col>
            </Row>
        </div>
    );
};

const Bulkupload: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams()
    const [loading, setLoading] = useState(false);
    const action = { fromUser: true };
    const dispatch = useAppDispatch()
    const store = useSelector((state: any) => state.Patients)
    const [value, setValue] = useState<string>('');
    const [sort, setSort] = useState<string>('asc');
    const [sortColumn, setSortColumn] = useState<any>('uploaded_date'); // Example initial sort column
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [eventId, setEventId] = useState<DeleteRowData[]>([]);
    const [patientstatus, setpatientstatus] = useState<string>('');
    const [eventId1, setEventId1] = useState(0);
    const selectedRowsPerPage: { [key: number]: DeleteRowData[] } = useMemo(() => ({}), []);
    const Username = localStorage.UserName;
    const [menuActions, setMenuActions] = useState<string>('');
    const [editOpen, setIsEditOpen] = useState<boolean>(false);
    const [editData, setIsEditData] = useState<PatientData | null>(null);
    const [editId, setEditId] = useState<string>('');
    const [RestartId, setRestartId] = useState<string>('');
    const [isDownloading, setIsDownloading] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [patientData, setPatientData] = useState<any>(null);
    const [viewingImage, setViewingImage] = useState<any>(false);

    const [unitedHealthcareOtpId, setUnitedHealthcareOtpId] = useState<string>('');
    const [isUnitedHealthcareOTPModalOpen, setIsUnitedHealthcareOTPModalOpen] = useState<boolean>(false);
    const [unitedHealthcareOtp, setUnitedHealthcareOtp] = useState("");
    const [isUnitedHealthcareVerifying, setIsUnitedHealthcareVerifying] = useState(false);
    const [unitedHealthcareOtpError, setUnitedHealthcareOtpError] = useState("");

    // const [GehaAuthenticationId, setGehaAuthenticationId] = useState<string>('');
    // const [isGehaAuthenticationModalOpen, setIsGehaAuthenticationModalOpen] = useState<boolean>(false);
    // const [GehaAuthenticationCode, setGehaAuthenticationCode] = useState("");
    // const [isGehaAuthenticationVerifying, setIsGehaAuthenticationVerifying] = useState(false);
    // const [GehaAuthenticationOtpError, setGehaAuthenticationOtpError] = useState("");

    const [KansasOtpId, setKansasOtpId] = useState<string>('');
    const [isKansasOTPModalOpen, setIsKansasOTPModalOpen] = useState<boolean>(false);
    const [kansasOtp, setKansasOtp] = useState("");
    const [iskansasOtpVerifying, setIskansasOtpVerifying] = useState<boolean>(false);
    const [kansasOtpError, setkansasOtpError] = useState<string>("");

    const [VirginiaOtpId, setVirginiaOtpId] = useState<string>('');
    const [isVirginiaOTPModalOpen, setIsVirginiaOTPModalOpen] = useState<boolean>(false);
    const [virginiaOtp, setVirginiaOtp] = useState("");
    const [isVirginiaVerifying, setIsVirginiaVerifying] = useState<boolean>(false);
    const [virginiaOtpError, setVirginiaOtpError] = useState<string>("");

    const [IowaOtpId, setIowaOtpId] = useState<string>('');
    const [isIowaOTPModalOpen, setIsIowaOTPModalOpen] = useState<boolean>(false);
    const [iowaOtp, setIowaOtp] = useState("");
    const [isIowaOtpVerifying, setIsIowaOtpVerifying] = useState<boolean>(false);
    const [IowaOtpError, setIowaOtpError] = useState<string>("");

    const [NortheastOtpId, setNortheastOtpId] = useState<string>('');
    const [isNortheastOTPModalOpen, setIsNortheastOTPModalOpen] = useState<boolean>(false);
    const [northeastOtp, setNortheastOtp] = useState("");
    const [isNortheastOtpVerifying, setIsNortheastOtpVerifying] = useState<boolean>(false);
    const [NortheastOtpError, setNortheastOtpError] = useState<string>("");

    const [GeorgiaOtpId, setGeorgiaOtpId] = useState<string>('');
    const [isGeorgiaOTPModalOpen, setIsGeorgiaOTPModalOpen] = useState<boolean>(false);
    const [georgiaOtp, setGeorgiaOtp] = useState("");
    const [isgeorgiaVerifying, setIsgeorgiaVerifying] = useState<boolean>(false);
    const [georgiaOtpError, setgeorgiaOtpError] = useState<string>("");

    const [GuardianOtpId, setGuardianOtpId] = useState<string>('');
    const [isGuardianOTPModalOpen, setIsGuardianOTPModalOpen] = useState<boolean>(false);
    const [guardianOtp, setGuardianOtp] = useState("");
    const [isguardianVerifying, setIsguardianVerifying] = useState<boolean>(false);
    const [guardianOtpError, setguardianOtpError] = useState<string>("");

    const [ArkansasOtpId, setArkansasOtpId] = useState<string>('');
    const [isArkansasOTPModalOpen, setIsArkansasOTPModalOpen] = useState<boolean>(false);
    const [arkansasOtp, setArkansasOtp] = useState("");
    const [isArkansasOtpVerifying, setIsArkansasOtpVerifying] = useState<boolean>(false);
    const [ArkansasOtpError, setArkansasOtpError] = useState<string>("");

    const [ColoradoOtpId, setColoradoOtpId] = useState<string>('');
    const [isColoradoOTPModalOpen, setIsColoradoOTPModalOpen] = useState<boolean>(false);
    const [coloradoOtp, setColoradoOtp] = useState("");
    const [isColoradoOtpVerifying, setIsColoradoOtpVerifying] = useState<boolean>(false);
    const [ColoradoOtpError, setColoradoOtpError] = useState<string>("");

    const [Individual_PlanOtpId, setIndividual_PlanOtpId] = useState<string>('');
    const [isIndividual_PlanOTPModalOpen, setIsIndividual_PlanOTPModalOpen] = useState<boolean>(false);
    const [individual_PlanOtp, setIndividual_PlanOtp] = useState("");
    const [isIndividual_PlanOtpVerifying, setIsIndividual_PlanOtpVerifying] = useState<boolean>(false);
    const [Individual_PlanOtpError, setIndividual_PlanOtpError] = useState<string>("");

    const [New_JerseyOtpId, setNew_JerseyOtpId] = useState<string>('');
    const [isNew_JerseyOTPModalOpen, setIsNew_JerseyOTPModalOpen] = useState<boolean>(false);
    const [new_JerseyOtp, setNew_JerseyOtp] = useState("");
    const [isNew_JerseyOtpVerifying, setIsNew_JerseyOtpVerifying] = useState<boolean>(false);
    const [New_JerseyOtpError, setNew_JerseyOtpError] = useState<string>("");

    const [New_YorkOtpId, setNew_YorkOtpId] = useState<string>('');
    const [isNew_YorkOTPModalOpen, setIsNew_YorkOTPModalOpen] = useState<boolean>(false);
    const [new_YorkOtp, setNew_YorkOtp] = useState("");
    const [isNew_YorkOtpVerifying, setIsNew_YorkOtpVerifying] = useState<boolean>(false);
    const [New_YorkOtpError, setNew_YorkOtpError] = useState<string>("");

    const [MassachusettsOtpId, setMassachusettsOtpId] = useState<string>('');
    const [isMassachusettsOTPModalOpen, setIsMassachusettsOTPModalOpen] = useState<boolean>(false);
    const [massachusettsOtp, setMassachusettsOtp] = useState("");
    const [isMassachusettsOtpVerifying, setIsMassachusettsOtpVerifying] = useState<boolean>(false);
    const [MassachusettsOtpError, setMassachusettsOtpError] = useState<string>("");

    const [WashingtonOtpId, setWashingtonOtpId] = useState<string>('');
    const [isWashingtonOTPModalOpen, setIsWashingtonOTPModalOpen] = useState<boolean>(false);
    const [washingtonOtp, setWashingtonOtp] = useState("");
    const [isWashingtonOtpVerifying, setIsWashingtonOtpVerifying] = useState<boolean>(false);
    const [WashingtonOtpError, setWashingtonOtpError] = useState<string>("");

    const [WisconsinOtpId, setWisconsinOtpId] = useState<string>('');
    const [isWisconsinOTPModalOpen, setIsWisconsinOTPModalOpen] = useState<boolean>(false);
    const [wisconsinOtp, setWisconsinOtp] = useState("");
    const [isWisconsinOtpVerifying, setIsWisconsinOtpVerifying] = useState<boolean>(false);
    const [WisconsinOtpError, setWisconsinOtpError] = useState<string>("");

    const [IllinoisOtpId, setIllinoisOtpId] = useState<string>('');
    const [isIllinoisOTPModalOpen, setIsIllinoisOTPModalOpen] = useState<boolean>(false);
    const [illinoisOtp, setIllinoisOtp] = useState("");
    const [isIllinoisOtpVerifying, setIsIllinoisOtpVerifying] = useState<boolean>(false);
    const [IllinoisOtpError, setIllinoisOtpError] = useState<string>("");

    const [RhodeIslandOtpId, setRhodeIslandOtpId] = useState<string>('');
    const [isRhodeIslandOTPModalOpen, setIsRhodeIslandOTPModalOpen] = useState<boolean>(false);
    const [rhodeIslandOtp, setRhodeIslandOtp] = useState("");
    const [isRhodeIslandOtpVerifying, setIsRhodeIslandOtpVerifying] = useState<boolean>(false);
    const [RhodeIslandOtpError, setRhodeIslandOtpError] = useState<string>("");

    const [OklahomaOtpId, setOklahomaOtpId] = useState<string>('');
    const [isOklahomaOTPModalOpen, setIsOklahomaOTPModalOpen] = useState<boolean>(false);
    const [oklahomaOtp, setOklahomaOtp] = useState("");
    const [isOklahomaVerifying, setIsOklahomaVerifying] = useState<boolean>(false);
    const [oklahomaOtpError, setOklahomaOtpError] = useState<string>("");

    const [AmertiasOtpId, setAmertiasOtpId] = useState<string>('');
    const [isAmertiasOTPModalOpen, setIsAmertiasOTPModalOpen] = useState<boolean>(false);
    const [amertiasOtp, setAmertiasOtp] = useState("");
    const [isAmertiasVerifying, setIsAmertiasVerifying] = useState<boolean>(false);
    const [AmertiasOtpError, setAmertiasOtpError] = useState<string>("");

    const [MissouriOtpId, setMissouriOtpId] = useState<string>('');
    const [isMissouriOTPModalOpen, setIsMissouriOTPModalOpen] = useState<boolean>(false);
    const [missouriOtp, setMissouriOtp] = useState("");
    const [isMissouriVerifying, setIsMissouriVerifying] = useState<boolean>(false);
    const [missouriOtpError, setMissouriOtpError] = useState<string>("");

    const [toolkitOtpId, setToolkitOtpId] = useState<string>('');
    const [isToolkitOTPModalOpen, setIsToolkitOTPModalOpen] = useState<boolean>(false);
    const [toolkitOtp, setToolkitOtp] = useState("");
    const [isToolkitVerifying, setIsToolkitVerifying] = useState<boolean>(false);
    const [toolkitOtpError, setToolkitOtpError] = useState<string>("");

    const [cignaOtpId, setCignaOtpId] = useState<string>('');
    const [isCignaOTPModalOpen, setIsCignaOTPModalOpen] = useState<boolean>(false);
    const [cignaOtp, setCignaOtp] = useState("");
    const [isCignaVerifying, setIsCignaVerifying] = useState<boolean>(false);
    const [cignaOtpError, setCignaOtpError] = useState<string>("");

    const [userId, setUserId] = useState<string>('');
    const UserType = localStorage.UserType;
    const Role = localStorage.Role
    const LoginUser = localStorage.getItem('UserName') || '';

    const [Id, setId] = useState<string>('');
    const User_Id = localStorage.getItem('id') || '';
    const [scrollInnerModal, setScrollInnerModal] = useState<boolean>(false);
    const [filteredAuditData, setFilteredAuditData] = useState<any[]>([]);
    const [refid, setRefid] = useState<string | null>(null);
    const [formValues, setFormValues] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        memberId: "",
        patientType: "",
        dob: "",
        providerNpi: "",
        insurance: "",
        feeSchedule: "",
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues({
            ...formValues,
            [e.target.name]: e.target.value,
        });
    };

    useEffect(() => {
        if (localStorage.id !== null) {
            dispatch(Get_permission(localStorage.id)).then((response) => {
                const res1 = response.payload;
                const Action = res1[0].Permission.filter(
                    (item: any) => item.MenuKey === "PATIENTS"
                );
                setMenuActions(Action[0].MenuActions);
            });
        }
    }, [localStorage.id])

    const [localData, setLocalData] = useState<DeleteRowData[]>(store.data);


    // Unified data fetching function with all parameters
    const fetchDataWithParams = useCallback(async (params: {
        q?: string;
        perPage?: number;
        page?: number;
        sort?: string;
        sortColumn?: string;
    } = {}) => {
        if (id !== undefined) {
            try {
                const actionResult = await dispatch(
                    getPatientData({
                        id,
                        q: params.q !== undefined ? params.q : value,
                        perPage: params.perPage !== undefined ? params.perPage : rowsPerPage,
                        page: params.page !== undefined ? params.page : currentPage,
                        sort: params.sort !== undefined ? params.sort : sort,
                        sortColumn: params.sortColumn !== undefined ? params.sortColumn : sortColumn
                    })
                );
                const payload = actionResult.payload as { data: DeleteRowData[] };
                setLocalData(payload.data);
            } catch (error) {
                console.error("Error fetching patient data:", error);
            }
        }
    }, [dispatch, id, value, rowsPerPage, currentPage, sort, sortColumn]);

    useEffect(() => {
        if (UserType === 'Vendor') {
            setId(localStorage.getItem('VendorId') || '');
        } else
            if (UserType === 'Client') {
                setId(localStorage.getItem('ClientId') || '');
            }
            else if (UserType === 'MOS') {
                setId(localStorage.getItem('id') || '');
            }
    }, [UserType]);

    // Fetch initial data only once on mount
    useEffect(() => {
        if (id !== undefined) {
            fetchDataWithParams({});
        }
    }, [id, fetchDataWithParams]);

    // useEffect for WebSocket connection
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = (event) => {
            const change = JSON.parse(event.data);

            setLocalData((prevData: DeleteRowData[]) =>
                prevData.map((item) =>
                    item.id === change.documentKey._id.$oid
                        ? { ...item, ...change.updateDescription.updatedFields }
                        : item
                )
            );
        };

        return () => {
            if (socket.readyState === WebSocket.OPEN) {
                socket.close();
            }
        };
    }, [websocket_webservice]);

    // United Healthcare OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_UnitedHealthcare_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("UNITED");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_UnitedHealthcare_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("UNITED");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setUnitedHealthcareOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setUnitedHealthcareOtp("");
                            setIsUnitedHealthcareVerifying(false);
                            setUnitedHealthcareOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsUnitedHealthcareOTPModalOpen(true);
                        }
                    }
                }

                // 3) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === unitedHealthcareOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsUnitedHealthcareVerifying(false);
                        setUnitedHealthcareOtp('');
                        setUnitedHealthcareOtpError("");
                        setIsUnitedHealthcareOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsUnitedHealthcareVerifying(false);
                        setUnitedHealthcareOtp('');
                        setUnitedHealthcareOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared

                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsUnitedHealthcareVerifying(false);
                        setIsUnitedHealthcareOTPModalOpen(false);

                        Swal.fire({
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, unitedHealthcareOtpId, userId]);

    // Kansas OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            // Trigger only when otp_status updates
            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Kansas_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("KANSAS");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Kansas_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((res) => res.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem('currentBatchInsuranceName') || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("KANSAS");
                        if (
                            (TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)
                        ) {
                            setKansasOtpId(TempData?.[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setKansasOtp('');
                            setIskansasOtpVerifying(false);
                            setkansasOtpError('');
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsKansasOTPModalOpen(true);
                        }
                    }
                }

                // 2) Handle other statuses for Kansas
                if (receivedId && receivedId === KansasOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIskansasOtpVerifying(false);
                        setKansasOtp('');
                        setkansasOtpError('');
                        setIsKansasOTPModalOpen(false);

                        Swal.fire({
                            icon: 'success',
                            title: 'Insurance Verification Platform',
                            text: 'OTP verified successfully.',
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: 'btn btn-success' },
                            allowOutsideClick: false,
                        });
                    } else if (status === 'R') {
                        // Incorrect OTP
                        setIskansasOtpVerifying(false);
                        setKansasOtp('');
                        setkansasOtpError('OTP incorrect. Please enter correct OTP.');
                    } else if (status === 'E') {
                        // Failed OTP validation
                        setIskansasOtpVerifying(false);
                        setIsKansasOTPModalOpen(false);
                        Swal.fire({
                            icon: 'error',
                            title: 'Insurance Verification Platform',
                            text: 'Time Out',
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: 'btn btn-danger' },
                            allowOutsideClick: false,
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, KansasOtpId, userId]);

    // Virginia OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            // Trigger only when otp_status updates
            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Virginia_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("VIRGINIA");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);

                        const response = await api.fetch('api/mfa_otp/get_Virginia_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("VIRGINIA");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setVirginiaOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setVirginiaOtp("");
                            setIsVirginiaVerifying(false);
                            setVirginiaOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsVirginiaOTPModalOpen(true);
                        }
                    }
                }

                // 2) Handle other statuses for Virginia
                if (receivedId && receivedId === VirginiaOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsVirginiaVerifying(false);
                        setVirginiaOtp('');
                        setVirginiaOtpError("");
                        setIsVirginiaOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP
                        setIsVirginiaVerifying(false);
                        setVirginiaOtp('');
                        setVirginiaOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        // Failed OTP validation
                        setIsVirginiaVerifying(false);
                        setIsVirginiaOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, VirginiaOtpId, userId]);

    // Iowa OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            // Trigger only when otp_status updates
            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Iowa_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("IOWA");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);

                        const response = await api.fetch('api/mfa_otp/get_Iowa_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("IOWA");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setIowaOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setIowaOtp("");
                            setIsIowaOtpVerifying(false);
                            setIowaOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsIowaOTPModalOpen(true);
                        }
                    }
                }

                // 2) Handle other statuses for Iowa
                if (receivedId && receivedId === IowaOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsIowaOtpVerifying(false);
                        setIowaOtp('');
                        setIowaOtpError("");
                        setIsIowaOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP
                        setIsIowaOtpVerifying(false);
                        setIowaOtp('');
                        setIowaOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        // Failed OTP validation
                        setIsIowaOtpVerifying(false);
                        setIsIowaOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, IowaOtpId, userId]);

    // Northeast OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            // Trigger only when otp_status updates
            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Northeast_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("NORTHEAST");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);

                        const response = await api.fetch('api/mfa_otp/get_Northeast_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("NORTHEAST");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setNortheastOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setNortheastOtp("");
                            setIsNortheastOtpVerifying(false);
                            setNortheastOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsNortheastOTPModalOpen(true);
                        }
                    }
                }

                // 2) Handle other statuses for Northeast
                if (receivedId && receivedId === NortheastOtpId && userId === User_Id) {
                    if (status === 'C') {
                        setIsNortheastOtpVerifying(false);
                        setNortheastOtp('');
                        setNortheastOtpError("");
                        setIsNortheastOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        setIsNortheastOtpVerifying(false);
                        setNortheastOtp('');
                        setNortheastOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        setIsNortheastOtpVerifying(false);
                        setIsNortheastOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, NortheastOtpId, userId]);

    // Georgia OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            // Trigger only when otp_status updates
            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Georgia_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("GEORGIA");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);

                        const response = await api.fetch('api/mfa_otp/get_Georgia_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("GEORGIA");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setGeorgiaOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setGeorgiaOtp("");
                            setIsgeorgiaVerifying(false);
                            setgeorgiaOtpError("");
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsGeorgiaOTPModalOpen(true);
                        }
                    }
                }

                // 2) Handle other statuses for Oklahoma
                if (receivedId && receivedId === GeorgiaOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsgeorgiaVerifying(false);
                        setGeorgiaOtp('');
                        setgeorgiaOtpError("");
                        setIsGeorgiaOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP
                        setIsgeorgiaVerifying(false);
                        setGeorgiaOtp('');
                        setgeorgiaOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        // Failed OTP validation
                        setIsgeorgiaVerifying(false);
                        setIsGeorgiaOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, GeorgiaOtpId, userId]);

    // Guardian OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Guardian_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("GUARDIAN");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Guardian_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("GUARDIAN");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setGuardianOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setGuardianOtp("");
                            setIsguardianVerifying(false);
                            setguardianOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsGuardianOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === GuardianOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsguardianVerifying(false);
                        setGuardianOtp('');
                        setguardianOtpError("");
                        setIsGuardianOTPModalOpen(false);
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsguardianVerifying(false);
                        setGuardianOtp('');
                        setguardianOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared
                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsguardianVerifying(false);
                        setIsGuardianOTPModalOpen(false);
                        setGuardianOtp('');
                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                        // Modal stays open, user can re-enter
                    }
                }

            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, GuardianOtpId, userId]);

    // Arkansas OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Arkansas_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("ARKANSAS");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N'
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);

                        const response = await api.fetch('api/mfa_otp/get_Arkansas_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("ARKANSAS");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setArkansasOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setArkansasOtp("");
                            setIsArkansasOtpVerifying(false);
                            setArkansasOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsArkansasOTPModalOpen(true);
                        }
                    }
                }

                // 2) Handle other statuses for Arkansas
                if (receivedId && receivedId === ArkansasOtpId && userId === User_Id) {
                    if (status === 'C') {
                        setIsArkansasOtpVerifying(false);
                        setArkansasOtp('');
                        setArkansasOtpError("");
                        setIsArkansasOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        setIsArkansasOtpVerifying(false);
                        setArkansasOtp('');
                        setArkansasOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        setIsArkansasOtpVerifying(false);
                        setIsArkansasOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, ArkansasOtpId, userId]);

    // Colorado OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Colorado_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("COLORADO");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N'
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);

                        const response = await api.fetch('api/mfa_otp/get_Colorado_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((r) => r.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("COLORADO");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setColoradoOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setColoradoOtp("");
                            setIsColoradoOtpVerifying(false);
                            setColoradoOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsColoradoOTPModalOpen(true);
                        }
                    }
                }

                // 2) Handle other statuses for Colorado
                if (receivedId && receivedId === ColoradoOtpId && userId === User_Id) {
                    if (status === 'C') {
                        setIsColoradoOtpVerifying(false);
                        setColoradoOtp('');
                        setColoradoOtpError("");
                        setIsColoradoOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false,
                        });

                    } else if (status === 'R') {
                        setIsColoradoOtpVerifying(false);
                        setColoradoOtp('');
                        setColoradoOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        setIsColoradoOtpVerifying(false);
                        setIsColoradoOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false,
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, ColoradoOtpId, userId]);

    // Individual Plan OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_IndividualPlan_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("INDIVIDUALPLAN");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N'
                if (status === 'N') {
                    if (receivedId) {
                        // Call API to fetch OTP details
                        const key = await keyPromise
                        const EncParams = await AesEncrypt(key, User_Id);

                        const response = await api.fetch('api/mfa_otp/get_IndividualPlan_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);
                        // Match OTP record with logged-in user
                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("INDIVIDUALPLAN");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setIndividual_PlanOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setIndividual_PlanOtp('');
                            setIsIndividual_PlanOtpVerifying(false);
                            setIndividual_PlanOtpError('');
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsIndividual_PlanOTPModalOpen(true); // 🔔 Open popup
                        }
                    }
                }

                // 2) Handle other statuses for Colorado
                if (receivedId && receivedId === Individual_PlanOtpId && userId === User_Id) {
                    if (status === 'C') {
                        setIsIndividual_PlanOtpVerifying(false);
                        setIndividual_PlanOtp('');
                        setIndividual_PlanOtpError("");
                        setIsIndividual_PlanOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false,
                        });

                    } else if (status === 'R') {
                        setIsIndividual_PlanOtpVerifying(false);
                        setIndividual_PlanOtp('');
                        setIndividual_PlanOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        setIsIndividual_PlanOtpVerifying(false);
                        setIsIndividual_PlanOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false,
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, Individual_PlanOtpId, userId]);

    // New Jersey OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA' → close the validation loading popup automatically
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_NewJersey_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("NEWJERSEY");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close(); // Auto-close the validation loading popup
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N'
                if (status === 'N') {
                    if (receivedId) {
                        // Call API to fetch OTP details
                        const key = await keyPromise
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_NewJersey_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);
                        // Match OTP record with logged-in user
                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("NEWJERSEY");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setNew_JerseyOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setNew_JerseyOtp('');
                            setIsNew_JerseyOtpVerifying(false);
                            setNew_JerseyOtpError('')
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsNew_JerseyOTPModalOpen(true); // 🔔 Open popup
                        }
                    }
                }

                // 2) Handle other statuses for Colorado
                if (receivedId && receivedId === New_JerseyOtpId && userId === User_Id) {
                    if (status === 'C') {
                        setIsNew_JerseyOtpVerifying(false);
                        setNew_JerseyOtp('');
                        setNew_JerseyOtpError("");
                        setIsNew_JerseyOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false,
                        });

                    } else if (status === 'R') {
                        setIsNew_JerseyOtpVerifying(false);
                        setNew_JerseyOtp('');
                        setNew_JerseyOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        setIsNew_JerseyOtpVerifying(false);
                        setIsNew_JerseyOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false,
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, New_JerseyOtpId, userId]);

    // New York OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_NewYork_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("NEWYORK");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N'
                if (status === 'N') {
                    if (receivedId) {
                        // Call API to fetch OTP details
                        const key = await keyPromise
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_NewYork_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);
                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("NEWYORK");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setNew_YorkOtpId(TempData?.[0]?.id);
                            setNew_YorkOtp('');
                            setIsNew_YorkOtpVerifying(false);
                            setNew_YorkOtpError('')
                            Swal.close();
                            setIsNew_YorkOTPModalOpen(true); // 🔔 Open popup
                        }
                    }
                }

                // 2) When status becomes 'C', 'R', or 'E'
                if (receivedId && receivedId === New_YorkOtpId && userId === User_Id) {
                    if (status === 'C') {
                        setIsNew_YorkOtpVerifying(false);
                        setNew_YorkOtp('');
                        setNew_YorkOtpError("");
                        setIsNew_YorkOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false,
                        });

                    } else if (status === 'R') {
                        setIsNew_YorkOtpVerifying(false);
                        setNew_YorkOtp('');
                        setNew_YorkOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        setIsNew_YorkOtpVerifying(false);
                        setIsNew_YorkOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false,
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, New_YorkOtpId, userId]);

    // Massachusetts OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Massachusetts_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("MASSACHUSETTS");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N'
                if (status === 'N') {
                    if (receivedId) {
                        // Call API to fetch OTP details
                        const key = await keyPromise
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Massachusetts_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);
                        // Match OTP record with logged-in user
                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("MASSACHUSETTS");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setMassachusettsOtpId(TempData?.[0]?.id);
                            setUserId(TempData?.[0]?.Uploaded_userid);
                            setMassachusettsOtp('');
                            setIsMassachusettsOtpVerifying(false);
                            setMassachusettsOtpError('');
                            Swal.close();
                            setIsMassachusettsOTPModalOpen(true); // 🔔 Open popup
                        }
                    }
                }

                // 2) Handle other statuses for Colorado
                if (receivedId && receivedId === MassachusettsOtpId && userId === User_Id) {
                    if (status === 'C') {
                        setIsMassachusettsOtpVerifying(false);
                        setMassachusettsOtp('');
                        setMassachusettsOtpError("");
                        setIsMassachusettsOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-success" },
                            allowOutsideClick: false,
                        });

                    } else if (status === 'R') {
                        setIsMassachusettsOtpVerifying(false);
                        setMassachusettsOtp('');
                        setMassachusettsOtpError("OTP incorrect. Please enter correct OTP.");

                    } else if (status === 'E') {
                        setIsMassachusettsOtpVerifying(false);
                        setIsMassachusettsOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: { confirmButton: "btn btn-danger" },
                            allowOutsideClick: false,
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, MassachusettsOtpId, userId]);

    // Washington OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Washington_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("WASHINGTON");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Washington_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("WASHINGTON");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setWashingtonOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setWashingtonOtp("");
                            setIsWashingtonOtpVerifying(false);
                            setWashingtonOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsWashingtonOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === WashingtonOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsWashingtonOtpVerifying(false);
                        setWashingtonOtp('');
                        setWashingtonOtpError("");
                        setIsWashingtonOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsWashingtonOtpVerifying(false);
                        setWashingtonOtp('');
                        setWashingtonOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared

                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsWashingtonOtpVerifying(false);
                        setIsWashingtonOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, WashingtonOtpId, userId]);

    // Wisconsin OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Wisconsin_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("WISCONSIN");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Wisconsin_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("WISCONSIN");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setWisconsinOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setWisconsinOtp("");
                            setIsWisconsinOtpVerifying(false);
                            setWisconsinOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsWisconsinOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === WisconsinOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsWisconsinOtpVerifying(false);
                        setWisconsinOtp('');
                        setWisconsinOtpError("");
                        setIsWisconsinOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsWisconsinOtpVerifying(false);
                        setWisconsinOtp('');
                        setWisconsinOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared

                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsWisconsinOtpVerifying(false);
                        setIsWisconsinOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, WisconsinOtpId, userId]);

    // Illinois OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Illinois_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("ILLINOIS");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 1) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Illinois_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("ILLINOIS");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setIllinoisOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setIllinoisOtp("");
                            setIsIllinoisOtpVerifying(false);
                            setIllinoisOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsIllinoisOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === IllinoisOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsIllinoisOtpVerifying(false);
                        setIllinoisOtp('');
                        setIllinoisOtpError("");
                        setIsIllinoisOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsIllinoisOtpVerifying(false);
                        setIllinoisOtp('');
                        setIllinoisOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared

                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsIllinoisOtpVerifying(false);
                        setIsIllinoisOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, IllinoisOtpId, userId]);

    // Rhode Island OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_RhodeIsland_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("RHODEISLAND");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_RhodeIsland_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());

                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("RHODEISLAND");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setRhodeIslandOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setRhodeIslandOtp("");
                            setIsRhodeIslandOtpVerifying(false);
                            setRhodeIslandOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsRhodeIslandOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === RhodeIslandOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsRhodeIslandOtpVerifying(false);
                        setRhodeIslandOtp('');
                        setRhodeIslandOtpError("");
                        setIsRhodeIslandOTPModalOpen(false);

                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });

                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsRhodeIslandOtpVerifying(false);
                        setRhodeIslandOtp('');
                        setRhodeIslandOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared

                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsRhodeIslandOtpVerifying(false);
                        setIsRhodeIslandOTPModalOpen(false);

                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, RhodeIslandOtpId, userId]);

    // Oklahoma OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);

        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (
                change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Oklahoma_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("OKLAHOMA");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 1) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Oklahoma_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("OKLAHOMA");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setOklahomaOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setOklahomaOtp("");
                            setIsOklahomaVerifying(false);
                            setOklahomaOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsOklahomaOTPModalOpen(true); // open popup
                        }
                    }
                }
                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === OklahomaOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsOklahomaVerifying(false);
                        setOklahomaOtp('');
                        setOklahomaOtpError("");
                        setIsOklahomaOTPModalOpen(false);
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsOklahomaVerifying(false);
                        setOklahomaOtp('');
                        setOklahomaOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared
                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsOklahomaVerifying(false);
                        setIsOklahomaOTPModalOpen(false);
                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                        // Modal stays open, user can re-enter
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, OklahomaOtpId, userId]);

    // Amertias OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (
                change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Amertias_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("AMERTIAS");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_Amertias_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("AMERTIAS");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setAmertiasOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setAmertiasOtp("");
                            setIsAmertiasVerifying(false);
                            setAmertiasOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsAmertiasOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === AmertiasOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsAmertiasVerifying(false);
                        setAmertiasOtp('');
                        setAmertiasOtpError("");
                        setIsAmertiasOTPModalOpen(false);
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsAmertiasVerifying(false);
                        setAmertiasOtp('');
                        setAmertiasOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared
                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsAmertiasVerifying(false);
                        setIsAmertiasOTPModalOpen(false);
                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                        // Modal stays open, user can re-enter
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, AmertiasOtpId, userId]);


    // Missouri OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (
                change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_missouri_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("MISSOURI");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_missouri_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("MISSOURI");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setMissouriOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setMissouriOtp("");
                            setIsMissouriVerifying(false);
                            setMissouriOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsMissouriOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === MissouriOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsMissouriVerifying(false);
                        setMissouriOtp('');
                        setMissouriOtpError("");
                        setIsMissouriOTPModalOpen(false);
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsMissouriVerifying(false);
                        setMissouriOtp('');
                        setMissouriOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared
                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsMissouriVerifying(false);
                        setIsMissouriOTPModalOpen(false);
                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                        // Modal stays open, user can re-enter
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, MissouriOtpId, userId]);

    // Toolkit OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (
                change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_toolkit_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("TOOLKIT");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_toolkit_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("TOOLKIT");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setToolkitOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setToolkitOtp("");
                            setIsToolkitVerifying(false);
                            setToolkitOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsToolkitOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === toolkitOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsToolkitVerifying(false);
                        setToolkitOtp('');
                        setToolkitOtpError("");
                        setIsToolkitOTPModalOpen(false);
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsToolkitVerifying(false);
                        setToolkitOtp('');
                        setToolkitOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared
                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsToolkitVerifying(false);
                        setIsToolkitOTPModalOpen(false);
                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                        // Modal stays open, user can re-enter
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, toolkitOtpId, userId]);

    // Cigna OTP Process
    useEffect(() => {
        const socket = new WebSocket(`${websocket_webservice}ws/BulkuploadPatient/`);
        socket.onmessage = async (event) => {
            const change = JSON.parse(event.data);
            const updatedFields = change.updateDescription?.updatedFields || {};
            const receivedId = change.documentKey?._id?.$oid;

            if (
                change.operationType === 'update' && 'otp_status' in updatedFields) {
                const status = updatedFields.otp_status;

                // 1) When status becomes 'NA'
                if (status === 'NA' && localStorage.getItem('isBulkUploadProcessing') === 'true') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_cigna_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("CIGNA");
                        if ((TempData.length > 0 && TempData[0] && TempData?.[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            const insuranceName = (TempData.length > 0 ? TempData?.[0]?.Payer_name : batchInsurance) || "the patients";
                            localStorage.removeItem('isBulkUploadProcessing');
                            localStorage.removeItem('currentBatchPatientIds');
                            localStorage.removeItem('currentBatchInsuranceName');
                            Swal.close();
                            Swal.fire({
                                icon: "success",
                                title: "Insurance Verification Platform",
                                text: `Authentication complete for ${insuranceName}.`,
                                timer: 3000,
                                allowOutsideClick: false,
                            });
                        }
                    }
                }

                // 2) When status becomes 'N' → open modal for this user
                if (status === 'N') {
                    if (receivedId) {
                        const key = await keyPromise;
                        const EncParams = await AesEncrypt(key, User_Id);
                        const response = await api.fetch('api/mfa_otp/get_cigna_OTP', {
                            method: 'POST',
                            body: JSON.stringify({ EncParams })
                        }).then((response) => response.json());
                        const TempData = await AesDecrypt(key, response);

                        const currentBatchIds = JSON.parse(localStorage.getItem('currentBatchPatientIds') || '[]');
                        const batchInsurance = (localStorage.getItem("currentBatchInsuranceName") || "").toUpperCase();
                        const isMyInsurer = batchInsurance.includes("CIGNA");
                        if ((TempData?.[0]?.id && TempData[0]?.Uploaded_userid === User_Id) || (receivedId && currentBatchIds.includes(receivedId) && isMyInsurer)) {
                            setCignaOtpId(TempData[0]?.id || receivedId);
                            setUserId(TempData[0]?.Uploaded_userid || User_Id);
                            setCignaOtp("");
                            setIsCignaVerifying(false);
                            setCignaOtpError("");
                            localStorage.removeItem('isBulkUploadProcessing');
                            Swal.close();
                            setIsCignaOTPModalOpen(true); // open popup
                        }
                    }
                }

                // 2) All other statuses apply for the current OTP record of this user
                if (receivedId && receivedId === cignaOtpId && userId === User_Id) {
                    if (status === 'C') {
                        // OTP verified successfully
                        setIsCignaVerifying(false);
                        setCignaOtp('');
                        setCignaOtpError("");
                        setIsCignaOTPModalOpen(false);
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "OTP verified successfully.",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                    } else if (status === 'R') {
                        // Incorrect OTP → allow re-entry
                        setIsCignaVerifying(false);
                        setCignaOtp('');
                        setCignaOtpError("OTP incorrect. Please enter correct OTP.");
                        // Modal stays open, input cleared
                    } else if (status === 'E') {
                        // Failed to validate OTP
                        setIsCignaVerifying(false);
                        setIsCignaOTPModalOpen(false);
                        Swal.fire({
                            //icon: "error",
                            title: "Insurance Verification Platform",
                            text: "Time Out",
                            showConfirmButton: true,
                            timer: 3000,
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            allowOutsideClick: false
                        });
                        // Modal stays open, user can re-enter
                    }
                }
            }
        };

        return () => {
            socket.close();
        };
    }, [User_Id, cignaOtpId, userId]);

    const handleReloadTable = () => {
        dispatch(
            getPatientData({
                id,
                q: value,
                perPage: rowsPerPage,
                page: currentPage,
                sort,
                sortColumn
            })
        );
    };

    const handleFilter = (val: any) => {
        setValue(val);
        setCurrentPage(1);
        // Make single backend call with updated filter and reset page
        fetchDataWithParams({ q: val, page: 1 });
    }

    const handlePerPage = (e: any) => {
        const newPerPage = parseInt(e.target.value);
        setCurrentPage(1);
        setRowsPerPage(newPerPage);
        // Make single backend call with updated perPage and reset page
        fetchDataWithParams({ perPage: newPerPage, page: 1 });
    }

    const handlePagination = (page: any) => {
        const newPage = page.selected + 1;
        setCurrentPage(newPage);
        // Make single backend call with updated page
        fetchDataWithParams({ page: newPage });
    }

    const dataToRender = () => {
        const filters: any = { q: value };
        const isFiltered = Object.keys(filters).some(k => filters[k].length > 0);

        // helper to sort any array by uploaded_date (newest first)
        const sortByDateDesc = (arr: any[]) =>
            [...arr].sort(
                (a, b) =>
                    new Date(b.uploaded_date || 0).getTime() -
                    new Date(a.uploaded_date || 0).getTime()
            );

        if (localData.length > 0) {
            // if you have filtered/edited localData, sort that first
            return sortByDateDesc(localData);
        } else if (localData.length === 0 && isFiltered) {
            // no matches
            return [];
        } else {
            // full data: sort, then slice for current page
            const sortedAll = sortByDateDesc(store.allData);
            return sortedAll.slice(
                (currentPage - 1) * rowsPerPage,
                currentPage * rowsPerPage
            );
        }
    };


    const handleSort = (column: any, sortDirection: any) => {
        setSort(sortDirection);
        setSortColumn(column.sortField);
        // Make single backend call with updated sort parameters
        fetchDataWithParams({ sort: sortDirection, sortColumn: column.sortField });
    }

    const CustomPagination = () => {
        const count = Number(Math.ceil(store.total / rowsPerPage))

        return (
            <ReactPaginate
                previousLabel={<ChevronLeft size={16} />}
                nextLabel={<ChevronRight size={16} />}
                breakLabel="..."
                pageCount={count || 1}
                onPageChange={handlePagination}
                forcePage={currentPage !== 0 ? currentPage - 1 : 0}
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                activeClassName="active"
            />
        )
    }

    const handlePortalsPDFDocument = async (id: any, row: any) => {
        const patientId = row.id;
        setLoading(true);
        const key = await keyPromise
        try {
            const EncParams = await AesEncrypt(key, patientId);
            const response = await api.fetch("api/portals-pdfs", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });

            if (!response.ok) {
                throw new Error("Failed to download file");
            }

            const contentDisposition = response.headers.get("Content-Disposition");
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            let fileName: string;
            const cdMatch = contentDisposition && contentDisposition.match(/filename="?([^";\n]+)"?/);
            if (cdMatch && cdMatch[1]) {
                fileName = cdMatch[1];
            } else {
                const contentType = response.headers.get("Content-Type") || "";
                const ext = contentType.includes("zip") ? ".zip" : ".pdf";
                const rawName = (row.Patientname || "Patient").toString();
                const rawDob = (row.PatientDOB || "").toString();
                const safeName = rawName.replace(/[\\/:*?"<>|]/g, "").replace(/\s+/g, " ").trim().replace(/\s/g, "_");
                const safeDob = rawDob.replace(/[\\/:*?"<>|]/g, "").replace(/\s+/g, "-").replace(/\//g, "-");
                fileName = `${safeName}_${safeDob}${ext}`;
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading patient file:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenWordDocument = async (id: any, row: any) => {
        setIsDownloading(id)
        const filename = row + '.docx';
        const key = await keyPromise
        try {
            const EncParams = await AesEncrypt(key, id);

            const response = await api.fetch('api/AllMappedPatientsData', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });

            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setIsDownloading(null)
        } catch (error) {
            setIsDownloading(null)
            console.error('Error downloading file: ', error);
        }
    };

    const handleErrorClick = async (row: any) => {
        const patientId = row.id
        setLoading(true);
        try {
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, patientId);
            const response = await api.fetch("api/Email-fetchErrorDatas", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            }).then((res) => res.json());
            setLoading(false);
            setIsModalOpen(true);
            setPatientData(response[0]);
        } catch (error) {
            console.error("Error fetching patient data:", error);
        } finally {
            setLoading(false); // Hide loading after fetching data
        }

    };

    const handleregenrateDocument = async (rows: any[]) => {
        setLoading(true);
        try {
            const key = await keyPromise
            const ids = rows.map(row => row.id);
            const EncParams = await AesEncrypt(key, ids);
            const fetchResponse = await api.fetch("api/regenratepatients", {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });
            const data = await fetchResponse.json();
            const data1 = await AesDecrypt(key, data);

            // await axios.get(webservice + 'api/elligibilityapi');
            // First API call to check the condition
            // const eligibilityResponse = await axios.get(webservice + 'api/elligibilityapi');
            const eligibilityResponse = await api.fetch("api/elligibilityapi", {
                method: 'GET'
            }).then((res) => res.json());
            if (eligibilityResponse.data === 'done') {
                // const xmlcreation = await axios.get(webservice + 'api/elligibilityapi/Mapping');
                const xmlcreation = await api.fetch("api/elligibilityapi/Mapping", {
                    method: 'GET'
                }).then((res) => res.json());
                // console.log('XML creation triggered:', xmlcreation.data);
            } else {
                // console.log('API response is not "done". No XML creation triggered.');
            }
            if (data1 === "S") {
                Swal.fire({
                    icon: "success",
                    title: "Insurance Verification Platform",
                    text: "Patients have been Regenrated.",
                    customClass: {
                        confirmButton: "btn btn-success",
                    },
                    allowOutsideClick: false
                });
                setLoading(false);
                navigate(`/patients`);
            }
        } catch (error) {
            console.error('Error downloading file: ', error);
        }
    };

    //United Healthcare OTP Process start
    const UnitedHealthcareOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_UnitedHealthcare_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchUnitedHealthcareOTP = async () => {
            const response = await UnitedHealthcareOtp();
            if (response.length > 0 && response[0].id) {
                setUnitedHealthcareOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchUnitedHealthcareOTP();
    }, []);

    useEffect(() => {
        if (unitedHealthcareOtpId && userId === User_Id) {
            setIsUnitedHealthcareOTPModalOpen(true);
        }
    }, [unitedHealthcareOtpId]);

    const handleSubmitUnitedHealthcareOtp = async () => {
        const Otpdata = { Id: unitedHealthcareOtpId, unitedHealthcare_code: unitedHealthcareOtp, LoginUser: LoginUser };
        try {
            setIsUnitedHealthcareVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch('api/mfa_otp/Update_UnitedHealthcare_OTP', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            // If API says failure, stop verifying and show error
            if (responseData !== 'OTP Updated Successfully') {
                setIsUnitedHealthcareVerifying(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Insurance Verification Platform',
                    text: 'Failed to send OTP for verification. Please try again.',
                    showConfirmButton: true,
                    customClass: { confirmButton: 'btn btn-danger' },
                    allowOutsideClick: false,
                });
            }

            // On success, keep modal open; WebSocket will react to otp_status (C/R/E)
        } catch (error) {
            console.error('Error submitting OTP: ', error);
            setIsUnitedHealthcareVerifying(false);
            Swal.fire({
                icon: 'error',
                title: 'Insurance Verification Platform',
                text: 'An error occurred while submitting OTP.',
                showConfirmButton: true,
                customClass: { confirmButton: 'btn btn-danger' },
                allowOutsideClick: false,
            });
        }
    };
    //United Healthcare OTP Process end


    //GEHA Authentication  Process start
    // const Geha_Authentication = async () => {
    //     const key = await keyPromise
    //     const EncParams = await AesEncrypt(key, User_Id);
    //     const response = await api.fetch('api/BulkUpload/Geha-authentiction-code', {
    //         method: 'POST',
    //         body: JSON.stringify({ EncParams })
    //     }).then((response) => response.json());

    //     const TempData = await AesDecrypt(key, response);
    //     return TempData;
    // };

    // useEffect(() => {
    //     const fetchGehaAuthenticationStatus = async () => {
    //         const response = await Geha_Authentication();
    //         if (response.length > 0 && response[0].id) {
    //             setGehaAuthenticationId(response[0].id);
    //             setUserId(response[0].Uploaded_userid);
    //             setGehaAuthenticationCode(response[0].Geha_Authentication_code);
    //         } else {
    //         }
    //     };
    //     fetchGehaAuthenticationStatus();
    // }, []);

    // useEffect(() => {
    //     if (GehaAuthenticationId && userId === User_Id) {
    //         setIsGehaAuthenticationModalOpen(true);
    //     }
    // }, [GehaAuthenticationId]);

    // const handleGehaAuthenticationCodeConfirmed = async () => {
    //     const AuthenticationData = { Id: GehaAuthenticationId };
    //     try {
    //         setIsGehaAuthenticationVerifying(true);
    //         const key = await keyPromise;
    //         const EncParams = await AesEncrypt(key, AuthenticationData);
    //         const response = await api.fetch('api/BulkUpload/Geha-update-authentiction-status', {
    //             method: 'POST',
    //             body: JSON.stringify({ EncParams })
    //         });
    //         const responseData = await response.json();

    //         // If API says failure, stop verifying and show error
    //         if (responseData !== 'OTP Updated Successfully') {
    //             setIsGehaAuthenticationVerifying(false);
    //             Swal.fire({
    //                 icon: 'error',
    //                 title: 'Insurance Verification Platform',
    //                 text: 'Failed to confirm GEHA authentication code. Please try again.',
    //                 showConfirmButton: true,
    //                 customClass: { confirmButton: 'btn btn-danger' },
    //                 allowOutsideClick: false,
    //             });
    //         }

    //         // On success, keep modal open; WebSocket will react to Geha_Authentication_status (C/R/E)
    //     } catch (error) {
    //         console.error('Error confirming GEHA Authentication code: ', error);
    //         setIsGehaAuthenticationVerifying(false);
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Insurance Verification Platform',
    //             text: 'An error occurred while confirming the GEHA code.',
    //             showConfirmButton: true,
    //             customClass: { confirmButton: 'btn btn-danger' },
    //             allowOutsideClick: false,
    //         });
    //     }
    // };
    // //GEHA Authentication  Process end


    //Kansas OTP Process start
    const KansasOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Kansas_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchKansasOTP = async () => {
            const response = await KansasOtp();
            if (response.length > 0 && response[0].id) {
                setKansasOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchKansasOTP();
    }, []);

    useEffect(() => {
        if (KansasOtpId && userId === User_Id) {
            setIsKansasOTPModalOpen(true);
        }
    }, [KansasOtpId]);

    const handleSubmitkansasOtp = async () => {
        const Otpdata = { Id: KansasOtpId, kansas_code: kansasOtp, LoginUser: LoginUser };
        try {
            setIskansasOtpVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata); // Convert object to string before encryption
            const response = await api.fetch("api/mfa_otp/UpdateKansas_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIskansasOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIskansasOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Kansas OTP Process end

    //Virginia OTP Process start
    const VirginiaOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Virginia_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);

        return TempData;
    };

    useEffect(() => {
        const fetchVirginiaOTP = async () => {
            const response = await VirginiaOtp();
            if (response.length > 0 && response[0].id) {
                setVirginiaOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchVirginiaOTP();
    }, []);

    useEffect(() => {
        if (VirginiaOtpId && userId === User_Id) {
            setIsVirginiaOTPModalOpen(true);
        }
    }, [VirginiaOtpId]);

    const handleSubmitVirginiaOtp = async () => {
        const Otpdata = { Id: VirginiaOtpId, virginia_code: virginiaOtp, LoginUser: LoginUser };
        try {
            setIsVirginiaVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/UpdateVirginia_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsVirginiaVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // Keep modal open; WebSocket will close it on C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsVirginiaVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Virginia OTP Process end

    //Iowa OTP Process start
    const IowaOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Iowa_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchIowaOTP = async () => {
            const response = await IowaOtp();
            if (response.length > 0 && response[0].id) {
                setIowaOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchIowaOTP();
    }, []);

    useEffect(() => {
        if (IowaOtpId && userId === User_Id) {
            setIsIowaOTPModalOpen(true);
        }
    }, [IowaOtpId]);

    const handleSubmitIowaOtp = async () => {
        const Otpdata = { Id: IowaOtpId, Iowa_code: iowaOtp, LoginUser: LoginUser };
        try {
            setIsIowaOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/UpdateIowa_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsIowaOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }
            // Keep modal open; WebSocket will close it on C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsIowaOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Iowa OTP Process end

    //Northeast OTP Process start
    const NortheastOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Northeast_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchNortheastOTP = async () => {
            const response = await NortheastOtp();
            if (response.length > 0 && response[0].id) {
                setNortheastOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchNortheastOTP();
    }, []);

    useEffect(() => {
        if (NortheastOtpId && userId === User_Id) {
            setIsNortheastOTPModalOpen(true);
        }
    }, [NortheastOtpId]);

    const handleSubmitNortheastOtp = async () => {
        const Otpdata = { Id: NortheastOtpId, northeast_code: northeastOtp, LoginUser: LoginUser };
        try {
            setIsNortheastOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/UpdateNortheast_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsNortheastOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }
            // Modal stays open until WebSocket status C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsNortheastOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Northeast OTP Process end


    //Georgia OTP Process start
    const GeorgiaOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Georgia_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchGeorgiaOTP = async () => {
            const response = await GeorgiaOtp();
            if (response.length > 0 && response[0].id) {
                setGeorgiaOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchGeorgiaOTP();
    }, []);

    useEffect(() => {
        if (GeorgiaOtpId && userId === User_Id) {
            setIsGeorgiaOTPModalOpen(true);
        }
    }, [GeorgiaOtpId]);

    const handleSubmitGeorgiaOtp = async () => {
        const Otpdata = { Id: GeorgiaOtpId, georgia_code: georgiaOtp, LoginUser: LoginUser };
        try {
            setIsgeorgiaVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata); // Convert object to string before encryption
            const response = await api.fetch("api/mfa_otp/UpdateGeorgia_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIsgeorgiaVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsgeorgiaVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Georgia OTP Process end

    //Guardian OTP Process start
    const GuardianOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Guardian_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchGuardianOTP = async () => {
            const response = await GuardianOtp();
            if (response.length > 0 && response[0].id) {
                setGuardianOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchGuardianOTP();
    }, []);

    useEffect(() => {
        if (GuardianOtpId && userId === User_Id) {
            setIsGuardianOTPModalOpen(true);
        }
    }, [GuardianOtpId]);

    const handleSubmitGuardianOtp = async () => {
        const Otpdata = { Id: GuardianOtpId, guardian_code: guardianOtp, LoginUser: LoginUser };
        try {
            setIsguardianVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata); // Convert object to string before encryption
            const response = await api.fetch("api/mfa_otp/UpdateGuardian_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIsguardianVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsguardianVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Guardian OTP Process end

    //Arkansas OTP Process start
    const ArkansasOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Arkansas_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchArkansasOTP = async () => {
            const response = await ArkansasOtp();
            if (response.length > 0 && response[0].id) {
                setArkansasOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchArkansasOTP();
    }, []);

    useEffect(() => {
        if (ArkansasOtpId && userId === User_Id) {
            setIsArkansasOTPModalOpen(true);
        }
    }, [ArkansasOtpId]);

    const handleSubmitArkansasOtp = async () => {
        const Otpdata = { Id: ArkansasOtpId, arkansas_code: arkansasOtp, LoginUser: LoginUser };
        try {
            setIsArkansasOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/UpdateArkansas_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsArkansasOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }
            // Keep modal open; WebSocket will close it on C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsArkansasOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Arkansas OTP Process end

    //Colorado OTP Process start
    const ColoradoOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Colorado_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchColoradoOTP = async () => {
            const response = await ColoradoOtp();
            if (response.length > 0 && response[0].id) {
                setColoradoOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchColoradoOTP();
    }, []);

    useEffect(() => {
        if (ColoradoOtpId && userId === User_Id) {
            setIsColoradoOTPModalOpen(true);
        }
    }, [ColoradoOtpId]);

    const handleSubmitColoradoOtp = async () => {
        const Otpdata = { Id: ColoradoOtpId, colorado_code: coloradoOtp, LoginUser: LoginUser };
        try {
            setIsColoradoOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/Update_Colorado_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsColoradoOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: { confirmButton: "btn btn-danger" },
                    allowOutsideClick: false,
                });
            }
            // Modal stays open; WebSocket handles C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsColoradoOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: { confirmButton: "btn btn-danger" },
                allowOutsideClick: false,
            });
        }
    };
    //Colorado OTP Process end

    //Individual Plan OTP Process start
    const Individual_PlanOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_IndividualPlan_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchIndividual_PlanOTP = async () => {
            const response = await Individual_PlanOtp();
            if (response.length > 0 && response[0].id) {
                setIndividual_PlanOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchIndividual_PlanOTP();
    }, []);

    useEffect(() => {
        if (Individual_PlanOtpId && userId === User_Id) {
            setIsIndividual_PlanOTPModalOpen(true);
        }
    }, [Individual_PlanOtpId]);

    const handleSubmitIndividual_PlanOtp = async () => {
        const Otpdata = { Id: Individual_PlanOtpId, individual_Plan_code: individual_PlanOtp, LoginUser: LoginUser };
        try {
            setIsIndividual_PlanOtpVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata); // Convert object to string before encryption
            const response = await api.fetch("api/mfa_otp/Update_IndividualPlan_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();
            if (responseData !== "OTP Updated Successfully") {
                setIsIndividual_PlanOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: { confirmButton: "btn btn-danger" },
                    allowOutsideClick: false,
                });
            }
            // Modal stays open; WebSocket handles C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsIndividual_PlanOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: { confirmButton: "btn btn-danger" },
                allowOutsideClick: false,
            });
        }
    };
    //Individual Plan OTP Process end

    //New Jersey OTP Process start
    const New_JerseyOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_NewJersey_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchNew_JerseyOTP = async () => {
            const response = await New_JerseyOtp();
            if (response.length > 0 && response[0].id) {
                setNew_JerseyOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchNew_JerseyOTP();
    }, []);

    useEffect(() => {
        if (New_JerseyOtpId && userId === User_Id) {
            setIsNew_JerseyOTPModalOpen(true);
        }
    }, [New_JerseyOtpId]);

    const handleSubmitNew_JerseyOtp = async () => {
        const Otpdata = { Id: New_JerseyOtpId, New_Jersey_code: new_JerseyOtp, LoginUser: LoginUser };
        try {
            setIsNew_JerseyOtpVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata); // Convert object to string before encryption
            const response = await api.fetch("api/mfa_otp/Update_NewJersey_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();
            if (responseData !== "OTP Updated Successfully") {
                setIsNew_JerseyOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: { confirmButton: "btn btn-danger" },
                    allowOutsideClick: false,
                });
            }
            // Modal stays open; WebSocket handles C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsNew_JerseyOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: { confirmButton: "btn btn-danger" },
                allowOutsideClick: false,
            });
        }
    };
    //New Jersey OTP Process end

    //New York OTP Process start
    const New_YorkOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_NewYork_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchNew_YorkOTP = async () => {
            const response = await New_YorkOtp();
            if (response.length > 0 && response[0].id) {
                setNew_YorkOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchNew_YorkOTP();
    }, []);

    useEffect(() => {
        if (New_YorkOtpId && userId === User_Id) {
            setIsNew_YorkOTPModalOpen(true);
        }
    }, [New_YorkOtpId]);

    const handleSubmitNew_YorkOtp = async () => {
        const Otpdata = { Id: New_YorkOtpId, New_York_code: new_YorkOtp, LoginUser: LoginUser };
        try {
            setIsNew_YorkOtpVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata); // Convert object to string before encryption
            const response = await api.fetch("api/mfa_otp/Update_NewYork_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();
            if (responseData !== "OTP Updated Successfully") {
                setIsNew_YorkOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: { confirmButton: "btn btn-danger" },
                    allowOutsideClick: false,
                });
            }
            // Modal stays open; WebSocket handles C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsNew_YorkOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: { confirmButton: "btn btn-danger" },
                allowOutsideClick: false,
            });
        }
    };
    //New York OTP Process end

    //Massachusetts OTP Process start
    const MassachusettsOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Massachusetts_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchMassachusettsOTP = async () => {
            const response = await MassachusettsOtp();
            if (response.length > 0 && response[0].id) {
                setMassachusettsOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchMassachusettsOTP();
    }, []);

    useEffect(() => {
        if (MassachusettsOtpId && userId === User_Id) {
            setIsMassachusettsOTPModalOpen(true);
        }
    }, [MassachusettsOtpId]);

    const handleSubmitMassachusettsOtp = async () => {
        const Otpdata = { Id: MassachusettsOtpId, massachusetts_code: massachusettsOtp, LoginUser: LoginUser };
        try {
            setIsMassachusettsOtpVerifying(true);
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, Otpdata); // Convert object to string before encryption
            const response = await api.fetch("api/mfa_otp/Update_Massachusetts_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });
            const responseData = await response.json();
            if (responseData !== "OTP Updated Successfully") {
                setIsMassachusettsOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: { confirmButton: "btn btn-danger" },
                    allowOutsideClick: false,
                });
            }
            // Modal stays open; WebSocket handles C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsMassachusettsOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: { confirmButton: "btn btn-danger" },
                allowOutsideClick: false,
            });
        }
    };
    //Massachusetts OTP Process end

    //Washington OTP Process start
    const WashingtonOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Washington_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchWashingtonOTP = async () => {
            const response = await WashingtonOtp();
            if (response.length > 0 && response[0].id) {
                setWashingtonOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchWashingtonOTP();
    }, []);

    useEffect(() => {
        if (WashingtonOtpId && userId === User_Id) {
            setIsWashingtonOTPModalOpen(true);
        }
    }, [WashingtonOtpId]);

    const handleSubmitWashingtonOtp = async () => {
        const Otpdata = { Id: WashingtonOtpId, washington_code: washingtonOtp, LoginUser: LoginUser };

        try {
            setIsWashingtonOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/Update_Washington_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsWashingtonOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, keep modal open; WebSocket will change otp_status (V -> C/R/E)
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsWashingtonOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Washington OTP Process end

    //Wisconsin OTP Process start
    const WisconsinOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Wisconsin_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchWisconsinOTP = async () => {
            const response = await WisconsinOtp();
            if (response.length > 0 && response[0].id) {
                setWisconsinOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchWisconsinOTP();
    }, []);

    useEffect(() => {
        if (WisconsinOtpId && userId === User_Id) {
            setIsWisconsinOTPModalOpen(true);
        }
    }, [WisconsinOtpId]);

    const handleSubmitWisconsinOtp = async () => {
        const Otpdata = { Id: WisconsinOtpId, wisconsin_code: wisconsinOtp, LoginUser: LoginUser };

        try {
            setIsWisconsinOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/Update_Wisconsin_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsWisconsinOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, keep modal open; WebSocket will change otp_status (V -> C/R/E)
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsWisconsinOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Wisconsin OTP Process end

    //Illinois OTP Process start
    const IllinoisOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Illinois_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchIllinoisOTP = async () => {
            const response = await IllinoisOtp();
            if (response.length > 0 && response[0].id) {
                setIllinoisOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchIllinoisOTP();
    }, []);

    useEffect(() => {
        if (IllinoisOtpId && userId === User_Id) {
            setIsIllinoisOTPModalOpen(true);
        }
    }, [IllinoisOtpId]);

    const handleSubmitIllinoisOtp = async () => {
        const Otpdata = { Id: IllinoisOtpId, illinois_code: illinoisOtp, LoginUser: LoginUser };

        try {
            setIsIllinoisOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/Update_Illinois_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsIllinoisOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, keep modal open; WebSocket will change otp_status (V -> C/R/E)
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsIllinoisOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Illinois OTP Process end

    //Rhode Island OTP Process start
    const RhodeIslandOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_RhodeIsland_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchRhodeIslandOTP = async () => {
            const response = await RhodeIslandOtp();
            if (response.length > 0 && response[0].id) {
                setRhodeIslandOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchRhodeIslandOTP();
    }, []);

    useEffect(() => {
        if (RhodeIslandOtpId && userId === User_Id) {
            setIsRhodeIslandOTPModalOpen(true);
        }
    }, [RhodeIslandOtpId]);

    const handleSubmitRhodeIslandOtp = async () => {
        const Otpdata = { Id: RhodeIslandOtpId, rhodeIsland_code: rhodeIslandOtp, LoginUser: LoginUser };

        try {
            setIsRhodeIslandOtpVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/Update_RhodeIsland_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            if (responseData !== "OTP Updated Successfully") {
                setIsRhodeIslandOtpVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, keep modal open; WebSocket will change otp_status (V -> C/R/E)
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsRhodeIslandOtpVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Rhode Island OTP Process end

    //Oklahoma OTP Process start
    const OklahomaOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Oklahoma_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchOklahomaOTP = async () => {
            const response = await OklahomaOtp();
            if (response.length > 0 && response[0].id) {
                setOklahomaOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchOklahomaOTP();
    }, []);

    useEffect(() => {
        if (OklahomaOtpId && userId === User_Id) {
            setIsOklahomaOTPModalOpen(true);
        }
    }, [OklahomaOtpId]);

    const handleSubmitOklahomaOtp = async () => {
        const Otpdata = { Id: OklahomaOtpId, oklahoma_code: oklahomaOtp, LoginUser: LoginUser };

        try {
            setIsOklahomaVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch("api/mfa_otp/Update_Oklahoma_OTP", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIsOklahomaVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsOklahomaVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Oklahoma OTP Process end

    //Amertias OTP Process start
    const AmertiasOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_Amertias_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchAmertiasOTP = async () => {
            const response = await AmertiasOtp();
            if (response.length > 0 && response[0].id) {
                setAmertiasOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchAmertiasOTP();
    }, []);

    useEffect(() => {
        if (AmertiasOtpId && userId === User_Id) {
            setIsAmertiasOTPModalOpen(true);
        }
    }, [AmertiasOtpId]);

    const handleSubmitAmertiasOtp = async () => {
        const Otpdata = { Id: AmertiasOtpId, amertias_code: amertiasOtp, LoginUser: LoginUser };

        try {
            setIsAmertiasVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch('api/mfa_otp/Update_Amertias_OTP', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIsAmertiasVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsAmertiasVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Amertias OTP Process end


    //Missouri OTP Process start
    const MissouriOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_missouri_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchMissouriOTP = async () => {
            const response = await MissouriOtp();
            if (response.length > 0 && response[0].id) {
                setMissouriOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchMissouriOTP();
    }, []);

    useEffect(() => {
        if (MissouriOtpId && userId === User_Id) {
            setIsMissouriOTPModalOpen(true);
        }
    }, [MissouriOtpId]);

    const handleSubmitMissouriOtp = async () => {
        const Otpdata = { Id: MissouriOtpId, missouri_code: missouriOtp, LoginUser: LoginUser };

        try {
            setIsMissouriVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch('api/mfa_otp/Update_missouri_OTP', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIsMissouriVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsMissouriVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Missouri OTP Process end


    //Toolkit OTP Process start
    const ToolkitOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_toolkit_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchToolkitOTP = async () => {
            const response = await ToolkitOtp();
            if (response.length > 0 && response[0].id) {
                setToolkitOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchToolkitOTP();
    }, []);

    useEffect(() => {
        if (toolkitOtpId && userId === User_Id) {
            setIsToolkitOTPModalOpen(true);
        }
    }, [toolkitOtpId]);

    const handleSubmitToolkitOtp = async () => {
        const Otpdata = { Id: toolkitOtpId, toolkit_code: toolkitOtp, LoginUser: LoginUser };

        try {
            setIsToolkitVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch('api/mfa_otp/Update_toolkit_OTP', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIsToolkitVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsToolkitVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Toolkit OTP Process end

    //Cigna OTP Process start
    const CignaOtp = async () => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, User_Id);
        const response = await api.fetch('api/mfa_otp/get_cigna_OTP', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());

        const TempData = await AesDecrypt(key, response);
        return TempData;
    };

    useEffect(() => {
        const fetchCignaOTP = async () => {
            const response = await CignaOtp();
            if (response.length > 0 && response[0].id) {
                setCignaOtpId(response[0].id);
                setUserId(response[0].Uploaded_userid);
            } else {
            }
        };
        fetchCignaOTP();
    }, []);

    useEffect(() => {
        if (cignaOtpId && userId === User_Id) {
            setIsCignaOTPModalOpen(true);
        }
    }, [cignaOtpId]);

    const handleSubmitCignaOtp = async () => {
        const Otpdata = { Id: cignaOtpId, cigna_code: cignaOtp, LoginUser: LoginUser };

        try {
            setIsCignaVerifying(true);
            const key = await keyPromise;
            const EncParams = await AesEncrypt(key, Otpdata);
            const response = await api.fetch('api/mfa_otp/Update_cigna_OTP', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });

            const responseData = await response.json();

            // Just basic error handling – don't close modal here.
            if (responseData !== "OTP Updated Successfully") {
                setIsCignaVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: "Insurance Verification Platform",
                    text: "Failed to send OTP for verification. Please try again.",
                    showConfirmButton: true,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                    allowOutsideClick: false,
                });
            }

            // If successful, we STILL keep modal open and wait for WebSocket
            // to change otp_status from V -> C/R/E
        } catch (error) {
            console.error("Error submitting OTP: ", error);
            setIsCignaVerifying(false);
            Swal.fire({
                icon: "error",
                title: "Insurance Verification Platform",
                text: "An error occurred while submitting OTP.",
                showConfirmButton: true,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                allowOutsideClick: false,
            });
        }
    };
    //Cigna OTP Process end

    interface BootstrapCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
        id: string;
    }
    // Handle individual row checkbox change
    const BootstrapCheckbox = forwardRef<HTMLInputElement, BootstrapCheckboxProps>(
        ({ id, ...props }, ref) => (
            <div style={{ marginBottom: '10px', position: 'relative', left: '10px' }}>
                <input type='checkbox' id={id} ref={ref} {...props} />
            </div>
        )
    );

    const [showRegenerateButton, setShowRegenerateButton] = useState(false);
    const timezone = moment.tz.guess();
    const handleChangecheck = useCallback(
        ({ selectedRows }: any) => {
            const selectedEventIds = [];
            selectedRows.forEach((row: any) => {
                selectedEventIds.push(row.id);
                setpatientstatus(row.Data_Fetched)

                const uploadedDate = moment.utc(row.uploaded_date).tz(timezone);

                // Calculate end date by adding Dayscount to the uploaded date
                const endDate = uploadedDate.clone().add(row.Dayscount, 'days');

                // Get current date
                const currentDate = moment.utc(new Date()).tz(timezone);

                if (currentDate.isSameOrAfter(endDate)) {
                    setShowRegenerateButton(true);
                } else {
                    setShowRegenerateButton(false);
                }


            });

            setEventId(selectedRows)
            setEventId1(selectedEventIds.length)

            if (!action.fromUser)
                return;
            selectedRowsPerPage[currentPage] = selectedRows;
        },
        [currentPage, selectedRowsPerPage, action.fromUser]);

    const startViewTimer = () => {
        const startTime = new Date().getTime();
        localStorage.setItem('ViewStartTime', startTime.toString());
    };

    const handleEdit = async (row: any) => {
        if (!row || typeof row !== "object") return;
        setIsEditOpen(true)
        setIsEditData(row)
        setEditId(row.id)
    };

    const handleRestart = async (row: any) => {
        if (!row || typeof row !== "object") return;

        setRestartId(row.id);

        try {
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, row.id);
            const response = await api.fetch("api/restart_patient_data", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            });

            // Optional: handle response if needed
            // const result = await response.json();
            // console.log("Restart response:", result);

        } catch (error) {
            console.error("Error restarting patient data:", error);
        }
    };


    useEffect(() => {
        if (editOpen && editData) {
            setFormValues({
                firstName: editData.First_Name || "",
                middleName: editData.MiddleName || "",
                lastName: editData.Last_Name || "",
                memberId: editData.Memberid || "",
                patientType: editData.Type || "",
                dob: editData.PatientDOB || "",
                providerNpi: editData.Provider_ID || "",
                insurance: editData.Payer_name || "",
                feeSchedule: "", // Set default value if needed
            });
        }
    }, [editOpen, editData]);


    const handleSubmitEditdata = async () => {
        setLoading(true);
        const data = JSON.stringify({ editId, formValues }); // Convert to string before encryption
        const auditLogData = [
            {
                field: 'Patient Name',
                before: `${editData?.First_Name} ${editData?.Last_Name}` || '',
                after: `${formValues.firstName} ${formValues.lastName}`,
            },
            {
                field: 'Date of Birth',
                before: editData?.PatientDOB || '',
                after: formValues.dob,
            },
            {
                field: 'Member ID',
                before: editData?.Memberid || '',
                after: formValues.memberId,
            },
            {
                field: 'Provider NPI',
                before: editData?.Provider_ID || '',
                after: formValues.providerNpi,
            },
        ];
        const Refid = editData?.RefId || '';
        const Username = localStorage.getItem('UserName') || '';
        const auditData = { auditLogData, Username, Refid };
        try {
            const key = await keyPromise
            const EncParams = await AesEncrypt(key, data);
            const response = await api.fetch("api/edit_patient_data", {
                method: "POST",
                body: JSON.stringify({ EncParams })
            })
            const responseData = await response.json();
            if (responseData === "Patient Updated Successfully") {
                // await axios.post(webservice + 'api/BulkUpload/EditauditLogdata', auditData, {
                //     headers: { 'Content-type': 'application/json; charset=UTF-8' }
                // });
                await api.fetch("api/BulkUpload/EditauditLogdata", {
                    method: "POST",
                    body: JSON.stringify({ auditData })
                })
                Swal.fire({
                    icon: "success",
                    title: "Insurance Verification Platform",
                    text: "Patient Updated Successfully",
                    customClass: {
                        confirmButton: "btn btn-success",
                    },
                    allowOutsideClick: false
                });
                setIsEditOpen(false);
                setLoading(false);
                handleReloadTable();
            }
        } catch (error) {
            console.error("Error fetching patient data:", error);
        }
    };

    const ViewAuditLog = async (row: any) => {
        const Username = localStorage.UserName;
        const Userid = localStorage.id;
        const RefId = row.RefId;
        const Name = row.Patientname;
        const key = await keyPromise
        const Data = { Username, RefId, Name, Userid };
        const EncParams = await AesEncrypt(key, Data);
        const response = await api.fetch('api/BulkUpload/ViewAuditLog', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());
        return response;
    };
    const DownloadAuditLog = async (row: any) => {
        const Username = localStorage.UserName;
        const Userid = localStorage.id;
        const RefId = row.RefId;
        const Name = row.Patientname + " - " + "OutPut Downloaded";
        const key = await keyPromise
        const Data = { Username, RefId, Name, Userid };
        const EncParams = await AesEncrypt(key, Data);
        const response = await api.fetch('api/BulkUpload/DownloadAuditLog', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());
        return response;
    };
    const [regenrateLoading, setregenrateLoading] = useState<boolean>(false);

    const handleRegenerateDocument = async (row: any) => {
        const id = row.id
        const key = await keyPromise
        // setregenrateLoading(true);
        try {
            const EncParams = await AesEncrypt(key, id);

            const fetchResponse = await api.fetch('api/Patient/regenratepatients', {
                method: 'POST',
                body: JSON.stringify({ EncParams })
            });

            const auditLogData = row.First_Name + " " + row.Last_Name + " " + "Patient have been Regenrated."


            const Username = localStorage.UserName;
            const auditData = { auditLogData, Username, Refid: id }
            // const auditLogResponse = await axios.post(webservice + 'api/regenrate/regenrateauditLogdata', auditData, {
            //     headers: { 'Content-type': 'application/json; charset=UTF-8' }
            // });
            const auditLogResponse = await api.fetch('api/regenrate/regenrateauditLogdata', {
                method: 'POST',
                body: JSON.stringify({ auditData })
            });
            const data = await fetchResponse.json();
            const data1 = await AesDecrypt(key, data);

            if (data1 === "S") {
                Swal.fire({
                    icon: "success",
                    title: "Insurance Verification Platform",
                    text: "Patients have been Regenrated.",
                    customClass: {
                        confirmButton: "btn btn-success",
                    },
                    allowOutsideClick: false
                });
                handleReloadTable();
                setregenrateLoading(false);
                // navigate(`/patients`);
            }
        } catch (error) {
            console.error('Error downloading file: ', error);
        }
    };
    const Columns = [
        { name: 'Uploaded by', selector: (row: { UserName: string }) => row.UserName ? row.UserName : 'NA', sortable: true, width: "160px" },
        { name: 'Patient Name', selector: (row: { Patientname: string }) => row.Patientname ? row.Patientname : 'NA', sortable: true, width: "170px" },
        { name: 'Patient DOB', selector: (row: { PatientDOB: string }) => row.PatientDOB ? row.PatientDOB : 'NA', sortable: true, width: "160px" },
        { name: 'Member ID', selector: (row: { Memberid: string }) => row.Memberid ? row.Memberid : 'NA', sortable: true, width: "160px" },
        { name: 'Client Name', selector: (row: { CompanyName: string }) => row.CompanyName ? row.CompanyName : 'NA', sortable: true, width: "160px" },
        // { name: 'Payer ID', selector: (row: { Payer_ID: string }) => row.Payer_ID ? row.Payer_ID : 'NA', sortable: true, width: "160px" },
        { 
            name: 'Insurance Name', 
            selector: (row: { Payer_name: string }) => row.Payer_name ? row.Payer_name : 'NA', 
            sortable: true, 
            width: "220px",
            cell: (row: any) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {row.LogoUrl && (
                        <img 
                            src={row.LogoUrl} 
                            alt="Logo" 
                            style={{ width: '60px', height: '60px', objectFit: 'contain', marginRight: '10px' }} 
                        />
                    )}
                    <span>{row.Payer_name || 'NA'}</span>
                </div>
            )
        },
        { name: 'Provider ID', selector: (row: { Provider_ID: string }) => row.Provider_ID ? row.Provider_ID : 'NA', sortable: true, width: "160px" },
        { name: 'Type', selector: (row: { Type: string }) => row.Type ? row.Type : 'NA', sortable: true, width: "160px" },
        {
            name: (
                <>
                    Template <br /> Generation Time
                </>
            ),
            selector: (row: { template_mapping_time: string }) =>
                row.template_mapping_time ? `${row.template_mapping_time} sec` : "NA",
            sortable: true
        },
        // {
        //     name: (
        //         <>
        //             XML <br /> Conversion Time
        //         </>
        //     ),
        //     selector: (row: { xml_conversion_time: string }) =>
        //         row.xml_conversion_time ? `${row.xml_conversion_time} sec` : "NA",
        //     sortable: true
        // },
        {
            name: (
                <>
                    Execution Time
                </>
            ),
            selector: (row: { execution_time: string }) => row.execution_time ? `${row.execution_time} min` : "NA",
            sortable: true
        },
        { 
            name: 'BOT Status', 
            selector: (row: { Data_Fetched?: string; bot_status?: string; RPA_Status?: string }) => {
                const status = (row.bot_status !== undefined && row.bot_status !== null)
                    ? (row.RPA_Status || row.Data_Fetched)
                    : row.Data_Fetched;

                if (status === 'C' || status === 'c') return 'Completed';
                if (status === 'E' || status === 'e') return 'Error';
                if (status === 'I' || status === 'i') return 'In Progress';
                if (status === 'Y' || status === 'y' || status === 'B' || status === 'b') return 'Yet To Start';
                return status || 'NA';
            }, 
            sortable: true, 
            width: "160px" 
        },
        {
            name: (
                <>
                    Regenrate <br /> Patient
                </>
            ), selector: (row: { Regenratedpatient: string }) => row.Regenratedpatient ? row.Regenratedpatient : 'NA', sortable: true, width: "140px"
        },
        {
            name: (
                <>
                    Uploaded <br /> Date
                </>
            ), selector: (row: { uploaded_date: string }) => {
                return row.uploaded_date
                    ? moment.utc(row.uploaded_date)
                        .tz(moment.tz.guess())
                        .format('MM/DD/YYYY, HH:mm:ss')
                    : 'NA';
            }, sortable: true, width: "200px"
        },
        {
            name: "View Patient",
            width: "300px",

            cell: (row: DeleteRowData) => (
                <>
                    {row.Data_Fetched === "C" && menuActions.includes("edit") && (
                        <>
                            <FileText
                                size={17}
                                id="editIcon"
                                // color='rgba(22, 167, 9, 1)
                                color={row.template_creation === "C" ? 'rgba(22, 167, 9, 1)' : '#800080'}
                                onClick={() => {
                                    startViewTimer();
                                    ViewAuditLog(row);
                                    navigate(`/patient-eligibility/${row.id}?view=/bulkupload/patient/${id}`);
                                }}
                                style={{ cursor: 'pointer', marginRight: '10px' }}
                            />
                            <UncontrolledTooltip placement="top" target="editIcon">
                                View Patient Details
                            </UncontrolledTooltip>
                        </>
                    )}
                    {row.DataMapping === "C" && row.template_creation === "C" && row.Data_Fetched !== "E" && (
                        <div onClick={() => { handleOpenWordDocument(row.id, row.Patientname); DownloadAuditLog(row); }}>
                            {isDownloading === row.id ? (
                                <div className="spinner"></div>
                            ) : (
                                <Download size={20} style={{ cursor: 'pointer' }} />
                            )}
                        </div>
                    )}
                    &nbsp;&nbsp;&nbsp;
                    <div style={{ width: "20px", textAlign: "center" }}>
                        {row.Data_Fetched === "C" && (
                            <img
                                src={portaldownload}
                                alt="PDF"
                                width={20}
                                height={20}
                                style={{ cursor: "pointer" }}
                                onClick={() => handlePortalsPDFDocument(row.id, row)}
                            />
                        )}
                    </div>
                    {row.Data_Fetched === "E" && (
                        <>
                            <FileText
                                size={17}
                                id={`error_message_${row.id}`}  // Unique ID for each row
                                color="red"
                                onClick={() => {
                                    handleErrorClick(row);
                                }}
                                style={{ cursor: 'pointer', marginRight: '10px' }}
                            />
                            <UncontrolledTooltip placement="top" target={`error_message_${row.id}`}>
                                <p style={{ color: "#e61616" }}>{row.error_message}</p>
                            </UncontrolledTooltip>
                        </>
                    )}
                    &nbsp;&nbsp;&nbsp;
                    {(
                        (row.Data_Fetched?.trim() === "E" && row.error_message?.includes("Error in patient details")) ||
                        (row.Data_Fetched?.trim() === "E" && row.error_message === "Please enter a valid member ID")
                    ) && (
                            <>
                                <Edit size={20} style={{ cursor: 'pointer' }} id={`EditIcon-${row.id}`} onClick={() => { handleEdit(row); }} />
                                <UncontrolledTooltip placement="top" target={`EditIcon-${row.id}`}>
                                    Edit
                                </UncontrolledTooltip>
                            </>
                        )}
                    &nbsp;&nbsp;&nbsp;
                    {row.Data_Fetched?.trim() === "E" && menuActions.includes("restart") && (
                        <>
                            <RotateCcw size={20} style={{ cursor: 'pointer' }} id={`EditIcon-${row.id}`} onClick={() => { handleRestart(row); }} />
                            <UncontrolledTooltip placement="top" target={`EditIcon-${row.id}`}>
                                Restart
                            </UncontrolledTooltip>
                        </>
                    )}
                    {row.DataMapping === "C" && row.template_creation === "C" && row.Data_Fetched !== "E" && (
                        <div style={{ width: "40px", textAlign: "center" }}>
                            <a className="nav-link" onClick={() => handleRegenerateDocument(row)}>
                                <img
                                    src={regenrate}
                                    alt="Regenerate"
                                    width={25}
                                    height={25}
                                    style={{ cursor: "pointer" }}
                                    id={`regenIcon-${row.id}`}
                                />
                                <UncontrolledTooltip placement="top" target={`regenIcon-${row.id}`} style={{ backgroundColor: "#355876", color: "white" }}>
                                    Regenerate
                                </UncontrolledTooltip>
                            </a>
                        </div>
                    )}
                    {localStorage.UserType === "MOS" && row.Regenratedpatient !== "Yes" && (

                        <div style={{ width: "30px", textAlign: "center" }}>
                            <Eye
                                size={17}
                                color="#09d5ff"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setScrollInnerModal(true);
                                    setRefid(row.RefId);
                                }}
                            />

                        </div>
                    )}
                </>
            )
        },

    ]


    const customStyles = {
        rows: {
            style: {
                '&:hover': {
                    backgroundColor: '#f0f0f0',

                },
            },
        },
        headCells: {
            style: {
                backgroundColor: '#355876',
                color: 'white',
                fontSize: '16px',
            },
        },
    };







    const deletePatient = async (ids: any[]) => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, ids);
        await api.fetch('api/bulkupload/deletePatientdetails', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        });
    };

    const DeleteAuditLogdata = async (data: any[]) => {
        data.forEach(item => {
            item.Userid = localStorage.id;
            item.ParentUserId = localStorage.ParentUserId;
        });
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, data);
        const response = await api.fetch('api/bulkupload/deleteauditlog', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then(response => response.json());
        return response;
    };

    const DeletePatient = async (rows: any[]) => {
        const ids = rows.map(row => row.id);
        const auditData = rows.map(row => ({
            Username,
            RefId: row.RefId,
            Name: row.Patientname
        }));

        const deleteRow = async () => {
            Swal.fire({
                title: "Insurance Verification Platform",
                text: "Are you sure do you want to delete?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-danger ms-1",
                },
                buttonsStyling: false,
                allowOutsideClick: false
            })
                .then(async function (result) {
                    if (result.isConfirmed) {
                        await deletePatient(ids);
                        const res = await DeleteAuditLogdata(auditData);
                        // ✅ Remove deleted rows from localData
                        setLocalData(prev => prev.filter(item => !ids.includes(item.id)));
                        fetchDataWithParams({})
                        Swal.fire({
                            icon: "success",
                            title: "Insurance Verification Platform",
                            text: "Clients have been deleted.",
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                            allowOutsideClick: false
                        });
                        handleReloadTable();
                        // fetchPatientData()
                    }
                });
        };
        deleteRow();
    };


    const startIndex = (currentPage - 1) * rowsPerPage + 1;

    const endIndex = Math.min(currentPage * rowsPerPage, store.total);
    const CustomLoadingComponent = () => {
        return (
            <div className="">
                {store.no_Data === 'There is no Record Found' ? (
                    <h4>
                        <br />
                        <p>There are no records to display</p>
                    </h4>
                ) : (
                    <div className="custom-loader">
                        <label className="custom-label">Please wait...</label>
                        <div className="custom-loading"></div>
                    </div>
                )}
            </div>
        );
    };

    const Exportrow = async (rows: any) => {
        setLoading(true);
        // Extract only the necessary columns
        const filteredData = rows.map((row: any) => ({
            OnederfulId: row.onederfulId,
            Error_message: row.error_message,
            Error_reason: row.error_reason,
        }));

        // Create a new workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Selected Data');

        // Add header row with styling
        const headerRow = worksheet.addRow(['OnederfulId', 'Error_message', 'Error_reason']);
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow background
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        // Set column widths (adjust these values based on your content)
        worksheet.getColumn(1).width = 40; // OnederfulId
        worksheet.getColumn(2).width = 50; // Error_message
        worksheet.getColumn(3).width = 50; // Error_reason

        // Add data rows
        filteredData.forEach((rows: any) => {
            worksheet.addRow([rows.OnederfulId, rows.Error_message, rows.Error_reason]);
        });

        // Export to Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Exported_Patient_Data.xlsx';
        link.click();

        // Clear selected rows and reset loading state
        selectedRowsPerPage[currentPage] = [];
        handleChangecheck({ selectedRows: [] });
        setLoading(false);
    };



    const getAuditlogdata = async (data: any) => {
        const key = await keyPromise
        const EncParams = await AesEncrypt(key, data);
        const response = await api.fetch('api/Bulk-upload-patients/get-audit-log-data', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
        }).then((response) => response.json());
        const TempData = await AesDecrypt(key, response);

        return TempData;
    };

    useEffect(() => {
        const fetchData = async () => {
            if (refid !== null) {
                const res = await getAuditlogdata(refid);
                setFilteredAuditData(res);
            }
        };
        fetchData();
    }, [refid]);


    const formatText = (text: any): string => {
        if (!text) return "";
        let str = String(text).toLowerCase(); // make lowercase
        return str.charAt(0).toUpperCase() + str.slice(1); // capitalize first letter
    };
    return (
        <Fragment>
            <Breadcrumbs mainTitle='View Patients' parent='Bulk Upload' title='View Patients' to={`/BulkUpload`} />
            <Card>
                <CardBody>
                    <div className="table-responsive">
                        <div className="dataTables_wrapper">
                            <DataTable
                                persistTableHead
                                subHeader={true}
                                responsive={true}
                                onSort={handleSort}
                                data={dataToRender()}
                                columns={Columns}
                                paginationServer
                                customStyles={customStyles}
                                paginationPerPage={rowsPerPage}
                                paginationDefaultPage={currentPage}
                                selectableRows
                                selectableRowsHighlight
                                selectableRowsComponent={BootstrapCheckbox as unknown as React.ReactNode}
                                onSelectedRowsChange={handleChangecheck}
                                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                                noDataComponent={<CustomLoadingComponent />}
                                paginationComponent={CustomPagination}
                                clearSelectedRows={loading}
                                subHeaderComponent={
                                    <CustomHeader
                                        value={value}
                                        rowsPerPage={rowsPerPage}
                                        handleFilter={handleFilter}
                                        handlePerPage={handlePerPage}
                                    />}
                            />
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ paddingLeft: '2%' }}>
                                    {store.total && (
                                        <span><strong>{`${startIndex} to ${endIndex} of ${store.total} entries`}</strong></span>
                                    )}
                                </div>
                                <div>
                                    <CustomPagination />
                                </div>
                            </div>
                        </div>
                    </div>
                </CardBody>
                {loading && (
                    <div >
                        <div className="loading-overlay">
                            <div id="page">
                                <div id="container">
                                    <div id="ring"></div>
                                    <div id="ring"></div>
                                    <div id="ring"></div>
                                    <div id="ring"></div>
                                    <div id="h3" style={{ color: "black" }}>loading...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </Card>
            <div>
                {eventId1 > 0 && menuActions.includes('delete') && (
                    <div className="customizer-links open">
                        <Nav className=" flex-column nav-pills">
                            <a className="nav-link" onClick={() => DeletePatient(eventId)}>
                                <span>Delete</span>
                                <Trash2 className="trash-icon" size={20} />
                            </a>
                        </Nav>
                    </div>
                )}
                {eventId1 > 0 && (
                    <div className="customizer1-links open">
                        <Nav className="flex-column nav-pills">
                            <a className="nav-link" onClick={() => Exportrow(eventId)}>
                                <span>Export</span>
                                <Download className="download-icon" size={20} />
                            </a>
                        </Nav>
                    </div>
                )}
            </div>
            <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} size="xl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px", maxHeight: "90vh", overflowY: "auto" }}>
                    {viewingImage ? (
                        // Full-screen image view
                        <>
                            <img
                                src={`data:image/jpeg;base64,${patientData.image_base64}`}
                                alt="Full Screen View"
                                style={{
                                    width: "100%",
                                    height: "90vh",
                                    objectFit: "contain",
                                    borderRadius: "8px",
                                }}
                            />
                            <button
                                onClick={() => setViewingImage(false)}
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    background: "red",
                                    color: "white",
                                    border: "none",
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                }}
                            >
                                ✕ Close
                            </button>
                        </>
                    ) : loading ? (
                        <p style={{ color: "black" }}>Loading data...</p>
                    ) : patientData ? (
                        // Main error details view
                        <div className="email-wrapper" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <p>{patientData.Payer_name}</p>
                            <h3>Error: {patientData.error_message}</h3>
                            <p>
                                Location:{" "}
                                <a href={patientData.error_page_url} target="_blank" rel="noopener noreferrer">
                                    {patientData.error_page_url}
                                </a>
                            </p>

                            {patientData.image_base64 ? (
                                <div style={{ marginTop: "15px" }}>
                                    <img
                                        src={`data:image/jpeg;base64,${patientData.image_base64}`}
                                        alt="Error Screenshot"
                                        style={{
                                            width: "100%",
                                            maxWidth: "500px",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            const imageUrl = `data:image/jpeg;base64,${patientData.image_base64}`;
                                            const newWindow = window.open();
                                            if (newWindow) {
                                                newWindow.document.write(
                                                    `<img src="${imageUrl}" style="width:100%;height:auto;object-fit:contain;" />`
                                                );
                                            }
                                        }}
                                    />

                                </div>
                            ) : (
                                <p>No image available</p>
                            )}
                        </div>
                    ) : (
                        <p>Please select a ticket to view details.</p>
                    )}
                </ModalBody>
            </Modal>

            {/* # United Healthcare OTP */}
            <Modal isOpen={isUnitedHealthcareOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a United Healthcare OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={unitedHealthcareOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isUnitedHealthcareVerifying && value.length <= 6) {
                                setUnitedHealthcareOtp(value);
                                if (unitedHealthcareOtpError) {
                                    setUnitedHealthcareOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isUnitedHealthcareVerifying}
                    />
                    {unitedHealthcareOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {unitedHealthcareOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitUnitedHealthcareOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={unitedHealthcareOtp.length !== 6 || isUnitedHealthcareVerifying}
                    >
                        {isUnitedHealthcareVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # GEHA OTP */}
            {/* <Modal
                isOpen={isGehaAuthenticationModalOpen}
                toggle={() => setIsGehaAuthenticationModalOpen(false)}
                size="sm"
                centered
                style={{ borderRadius: "16px", overflow: "hidden" }}
            >
                <ModalHeader
                    style={{
                        justifyContent: "center",
                        backgroundColor: "#f0f4f8",
                        fontWeight: "700",
                        fontSize: "20px",
                        borderBottom: "none",
                    }}
                >
                    🔐 GEHA Authentication
                </ModalHeader>

                <ModalBody
                    style={{
                        textAlign: "center",
                        padding: "30px",
                        backgroundColor: "#ffffff",
                    }}
                >
                    <p style={{ fontSize: "18px", fontWeight: "600", color: "#333" }}>
                        Your Authentication Code
                    </p>

                    <div
                        style={{
                            backgroundColor: "#e9f5ff",
                            borderRadius: "12px",
                            padding: "15px 25px",
                            display: "inline-block",
                            marginTop: "20px",
                            marginBottom: "30px",
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "#007bff",
                            letterSpacing: "2px",
                        }}
                    >
                        {GehaAuthenticationCode}
                    </div>
                    {GehaAuthenticationOtpError && (
                        <div style={{ color: 'red', marginTop: '10px', fontSize: '13px' }}>
                            {GehaAuthenticationOtpError}
                        </div>
                    )}
                </ModalBody>

                <ModalFooter
                    style={{
                        justifyContent: "center",
                        backgroundColor: "#f0f4f8",
                        borderTop: "none",
                        paddingBottom: "20px",
                    }}
                >
                    <Button
                        color="primary"
                        onClick={handleGehaAuthenticationCodeConfirmed}
                        disabled={GehaAuthenticationCode.length! == 6 || isGehaAuthenticationVerifying}
                        style={{
                            padding: "10px 30px",
                            fontSize: "16px",
                            borderRadius: "8px",
                            fontWeight: "600",
                        }}
                    >
                        {isGehaAuthenticationVerifying ? 'Confirming...' : 'OK'}
                    </Button>
                </ModalFooter>
            </Modal> */}

            {/* # Kansas OTP */}
            <Modal isOpen={isKansasOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: 'center', padding: '20px' }}>
                    <h4>Enter a Kansas OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={kansasOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!iskansasOtpVerifying && value.length <= 6) {
                                setKansasOtp(value);
                                if (kansasOtpError) {
                                    setkansasOtpError(''); // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={iskansasOtpVerifying}
                    />
                    {kansasOtpError && (
                        <div style={{ color: 'red', marginTop: '5px', fontSize: '13px' }}>
                            {kansasOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitkansasOtp}
                        style={{ marginTop: '10px', cursor: 'pointer' }}
                        disabled={kansasOtp.length !== 6 || iskansasOtpVerifying}
                    >
                        {iskansasOtpVerifying ? 'Verifying OTP...' : 'Submit'}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Virginia OTP */}
            <Modal isOpen={isVirginiaOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Virginia OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={virginiaOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isVirginiaVerifying && value.length <= 6) {
                                setVirginiaOtp(value);
                                if (virginiaOtpError) {
                                    setVirginiaOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isVirginiaVerifying}
                    />
                    {virginiaOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {virginiaOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitVirginiaOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={virginiaOtp.length !== 6 || isVirginiaVerifying}
                    >
                        {isVirginiaVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Iowa OTP */}
            <Modal isOpen={isIowaOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Iowa OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={iowaOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isIowaOtpVerifying && value.length <= 6) {
                                setIowaOtp(value);
                                if (IowaOtpError) {
                                    setIowaOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isIowaOtpVerifying}
                    />
                    {IowaOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {IowaOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitIowaOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={iowaOtp.length !== 6 || isIowaOtpVerifying}
                    >
                        {isIowaOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Northeast OTP */}
            <Modal isOpen={isNortheastOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Northeast Delta Dental OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={northeastOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isNortheastOtpVerifying && value.length <= 6) {
                                setNortheastOtp(value);
                                if (NortheastOtpError) {
                                    setNortheastOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isNortheastOtpVerifying}
                    />
                    {NortheastOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {NortheastOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitNortheastOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={northeastOtp.length !== 6 || isNortheastOtpVerifying}
                    >
                        {isNortheastOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Georgia OTP */}
            <Modal isOpen={isGeorgiaOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Georgia OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={georgiaOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isgeorgiaVerifying && value.length <= 6) {
                                setGeorgiaOtp(value);
                                if (georgiaOtpError) {
                                    setgeorgiaOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isgeorgiaVerifying}
                    />
                    {georgiaOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {georgiaOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitGeorgiaOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={georgiaOtp.length !== 6 || isgeorgiaVerifying}
                    >
                        {isgeorgiaVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Guardian OTP */}
            <Modal isOpen={isGuardianOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Guardian Life Insurance Co OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={guardianOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isguardianVerifying && value.length <= 6) {
                                setGuardianOtp(value);
                                if (guardianOtpError) {
                                    setguardianOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isguardianVerifying}
                    />
                    {guardianOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {guardianOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitGuardianOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={guardianOtp.length !== 6 || isguardianVerifying}
                    >
                        {isguardianVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Arkansas OTP */}
            <Modal isOpen={isArkansasOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Arkansas OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={arkansasOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isArkansasOtpVerifying && value.length <= 6) {
                                setArkansasOtp(value);
                                if (ArkansasOtpError) {
                                    setArkansasOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isArkansasOtpVerifying}
                    />
                    {ArkansasOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {ArkansasOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitArkansasOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={arkansasOtp.length !== 6 || isArkansasOtpVerifying}
                    >
                        {isArkansasOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Colorado OTP */}
            <Modal isOpen={isColoradoOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Colorado OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={coloradoOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isColoradoOtpVerifying && value.length <= 6) {
                                setColoradoOtp(value);
                                if (ColoradoOtpError) {
                                    setColoradoOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isColoradoOtpVerifying}
                    />
                    {ColoradoOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {ColoradoOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitColoradoOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={coloradoOtp.length !== 6 || isColoradoOtpVerifying}
                    >
                        {isColoradoOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Individual Plan OTP */}
            <Modal isOpen={isIndividual_PlanOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Individual Plan OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={individual_PlanOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numbers and max 6 digits
                            if (value.length <= 6) {
                                setIndividual_PlanOtp(value);
                                if (Individual_PlanOtpError) {
                                    setIndividual_PlanOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isIndividual_PlanOtpVerifying}
                    />
                    {Individual_PlanOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {Individual_PlanOtpError}
                        </div>
                    )}
                    <Button color="primary" onClick={handleSubmitIndividual_PlanOtp} style={{ marginTop: "10px", cursor: "pointer" }} disabled={individual_PlanOtp.length !== 6 || isIndividual_PlanOtpVerifying}>
                        {isIndividual_PlanOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # New Jersey OTP */}
            <Modal isOpen={isNew_JerseyOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of New Jersey OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={new_JerseyOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numbers and max 6 digits
                            if (value.length <= 6) {
                                setNew_JerseyOtp(value);
                                if (New_JerseyOtpError) {
                                    setNew_JerseyOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isNew_JerseyOtpVerifying}
                    />
                    {New_JerseyOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {New_JerseyOtpError}
                        </div>
                    )}
                    <Button color="primary" onClick={handleSubmitNew_JerseyOtp} style={{ marginTop: "10px", cursor: "pointer" }} disabled={new_JerseyOtp.length !== 6 || isNew_JerseyOtpVerifying}>
                        {isNew_JerseyOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # New York OTP */}
            <Modal isOpen={isNew_YorkOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of New York OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={new_YorkOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numbers and max 6 digits
                            if (value.length <= 6) {
                                setNew_YorkOtp(value);
                                if (New_YorkOtpError) {
                                    setNew_YorkOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isNew_YorkOtpVerifying}
                    />
                    {New_YorkOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {New_YorkOtpError}
                        </div>
                    )}
                    <Button color="primary" onClick={handleSubmitNew_YorkOtp} style={{ marginTop: "10px", cursor: "pointer" }} disabled={new_YorkOtp.length !== 6 || isNew_YorkOtpVerifying}>
                        {isNew_YorkOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Massachusetts OTP */}
            <Modal isOpen={isMassachusettsOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Massachusetts OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={massachusettsOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numbers and max 6 digits
                            if (value.length <= 6) {
                                setMassachusettsOtp(value);
                                if (MassachusettsOtpError) {
                                    setMassachusettsOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isMassachusettsOtpVerifying}
                    />
                    {MassachusettsOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {MassachusettsOtpError}
                        </div>
                    )}
                    <Button color="primary" onClick={handleSubmitMassachusettsOtp} style={{ marginTop: "10px", cursor: "pointer" }} disabled={massachusettsOtp.length !== 6 || isMassachusettsOtpVerifying}>
                        {isMassachusettsOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Washington OTP */}
            <Modal isOpen={isWashingtonOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Washington OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={washingtonOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isWashingtonOtpVerifying && value.length <= 6) {
                                setWashingtonOtp(value);
                                if (WashingtonOtpError) {
                                    setWashingtonOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isWashingtonOtpVerifying}
                    />
                    {WashingtonOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {WashingtonOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitWashingtonOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={washingtonOtp.length !== 6 || isWashingtonOtpVerifying}
                    >
                        {isWashingtonOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Wisconsin OTP */}
            <Modal isOpen={isWisconsinOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Wisconsin OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={wisconsinOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isWisconsinOtpVerifying && value.length <= 6) {
                                setWisconsinOtp(value);
                                if (WisconsinOtpError) {
                                    setWisconsinOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isWisconsinOtpVerifying}
                    />
                    {WisconsinOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {WisconsinOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitWisconsinOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={wisconsinOtp.length !== 6 || isWisconsinOtpVerifying}
                    >
                        {isWisconsinOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Illinois OTP */}
            <Modal isOpen={isIllinoisOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Illinois OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={illinoisOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isIllinoisOtpVerifying && value.length <= 6) {
                                setIllinoisOtp(value);
                                if (IllinoisOtpError) {
                                    setIllinoisOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isIllinoisOtpVerifying}
                    />
                    {IllinoisOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {IllinoisOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitIllinoisOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={illinoisOtp.length !== 6 || isIllinoisOtpVerifying}
                    >
                        {isIllinoisOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Rhode Island OTP */}
            <Modal isOpen={isRhodeIslandOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Rhode Island OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={rhodeIslandOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isRhodeIslandOtpVerifying && value.length <= 6) {
                                setRhodeIslandOtp(value);
                                if (RhodeIslandOtpError) {
                                    setRhodeIslandOtpError("");
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isRhodeIslandOtpVerifying}
                    />
                    {RhodeIslandOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {RhodeIslandOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitRhodeIslandOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={rhodeIslandOtp.length !== 6 || isRhodeIslandOtpVerifying}
                    >
                        {isRhodeIslandOtpVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Oklahoma OTP */}
            <Modal isOpen={isOklahomaOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Delta Dental of Oklahoma OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={oklahomaOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isOklahomaVerifying && value.length <= 6) {
                                setOklahomaOtp(value);
                                if (oklahomaOtpError) {
                                    setOklahomaOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isOklahomaVerifying}
                    />
                    {oklahomaOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {oklahomaOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitOklahomaOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={oklahomaOtp.length !== 6 || isOklahomaVerifying}
                    >
                        {isOklahomaVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Amertias OTP */}
            <Modal isOpen={isAmertiasOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Amertias OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={amertiasOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isAmertiasVerifying && value.length <= 6) {
                                setAmertiasOtp(value);
                                if (AmertiasOtpError) {
                                    setAmertiasOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isAmertiasVerifying}
                    />
                    {AmertiasOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {AmertiasOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitAmertiasOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={amertiasOtp.length !== 6 || isAmertiasVerifying}
                    >
                        {isAmertiasVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Missouri OTP */}
            <Modal isOpen={isMissouriOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Missouri OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={missouriOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isMissouriVerifying && value.length <= 6) {
                                setMissouriOtp(value);
                                if (missouriOtpError) {
                                    setMissouriOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isMissouriVerifying}
                    />
                    {missouriOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {missouriOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitMissouriOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={missouriOtp.length !== 6 || isMissouriVerifying}
                    >
                        {isMissouriVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Toolkit OTP */}
            <Modal isOpen={isToolkitOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Toolkit OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={toolkitOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isToolkitVerifying && value.length <= 6) {
                                setToolkitOtp(value);
                                if (toolkitOtpError) {
                                    setToolkitOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isToolkitVerifying}
                    />
                    {toolkitOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {toolkitOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitToolkitOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={toolkitOtp.length !== 6 || isToolkitVerifying}
                    >
                        {isToolkitVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            {/* # Cigna OTP */}
            <Modal isOpen={isCignaOTPModalOpen} backdrop="static" keyboard={false} size="sl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h4>Enter a Cigna OTP</h4>
                    <br />
                    <Input
                        type="text"
                        value={cignaOtp}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (!isCignaVerifying && value.length <= 6) {
                                setCignaOtp(value);
                                if (cignaOtpError) {
                                    setCignaOtpError("");   // clear error while typing
                                }
                            }
                        }}
                        placeholder="Enter 6-digit OTP"
                        maxLength={6}
                        disabled={isCignaVerifying}
                    />
                    {cignaOtpError && (
                        <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                            {cignaOtpError}
                        </div>
                    )}
                    <Button
                        color="primary"
                        onClick={handleSubmitCignaOtp}
                        style={{ marginTop: "10px", cursor: "pointer" }}
                        disabled={cignaOtp.length !== 6 || isCignaVerifying}
                    >
                        {isCignaVerifying ? "Verifying OTP..." : "Submit"}
                    </Button>
                </ModalBody>
            </Modal>

            <Modal isOpen={editOpen} toggle={() => setIsEditOpen(false)} size="xl" centered>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <Row style={{ marginTop: "2%" }}>
                        <Col xl={12}>
                            <h4><b>Edit Patient Details:</b></h4>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xl={4}>
                            <Label className="form-label" htmlFor="firstName">First Name</Label>
                            <Input
                                type="text"
                                name="firstName"
                                value={formValues.firstName}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col xl={4}>
                            <Label className="form-label" htmlFor="middleName">Middle Name</Label>
                            <Input
                                type="text"
                                name="middleName"
                                value={formValues.middleName}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col xl={4}>
                            <Label className="form-label" htmlFor="lastName">Last Name</Label>
                            <Input
                                type="text"
                                name="lastName"
                                value={formValues.lastName}
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "2%" }}>
                        <Col xl={4}>
                            <Label className="form-label" htmlFor="memberId">Member ID</Label>
                            <Input
                                type="text"
                                name="memberId"
                                value={formValues.memberId}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col xl={4}>
                            <Label className="form-label" htmlFor="dob">Date of Birth</Label>
                            <Input
                                type="text"
                                name="dob"
                                value={formValues.dob}
                                onChange={handleInputChange}
                            />
                        </Col>
                        <Col xl={4}>
                            <Label className="form-label" htmlFor="providerNpi">Provider NPI ID</Label>
                            <Input
                                type="text"
                                name="providerNpi"
                                value={formValues.providerNpi}
                                onChange={handleInputChange}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Button color="primary" onClick={handleSubmitEditdata} style={{ marginTop: "10px" }}>
                        Update
                    </Button>
                </ModalBody>
            </Modal>



            <div>
                <Modal
                    style={{ maxWidth: "1500px", maxHeight: "600px" }}
                    isOpen={scrollInnerModal}
                    toggle={() => setScrollInnerModal(!scrollInnerModal)}
                    className="modal-dialog-centered modal-lg"
                >
                    <ModalHeader toggle={() => setScrollInnerModal(!scrollInnerModal)}>
                        Bulk Upload Audit Log
                    </ModalHeader>
                    <ModalBody>
                        <div style={{ maxHeight: "600px", overflow: "auto" }}>
                            {filteredAuditData.length > 0 ? (
                                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                    <thead>
                                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                                            <th className="audit-tableHeaderStyle">Date & Time</th>
                                            <th className="audit-tableHeaderStyle">Action</th>
                                            <th className="audit-tableHeaderStyle">Data Set</th>
                                            <th className="audit-tableHeaderStyle">Changed By</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ alignItems: "center" }}>
                                        {filteredAuditData
                                            .sort(
                                                (a: AuditData, b: AuditData) =>
                                                    new Date(b.Modified).getTime() -
                                                    new Date(a.Modified).getTime()
                                            )
                                            .map((item: AuditData, index: number) => (
                                                <tr key={index}>
                                                    <td className="audit-tableDataStyle">
                                                        {(() => {
                                                            const localDate = moment
                                                                .utc(item.Modified)
                                                                .tz(moment.tz.guess())
                                                                .format("MM/DD/YYYY hh:mm:ss A");
                                                            return localDate;
                                                        })()}
                                                    </td>
                                                    <td className="audit-tableDataStyle">{item.Action}</td>
                                                    <td className="audit-tableDataStyle">
                                                        {item.Action === "VIEW" ? (
                                                            <pre>{JSON.stringify(formatText(item.JsonData), null, 2)}</pre>
                                                        ) : (
                                                            <table
                                                                style={{ borderCollapse: "collapse", width: "100%" }}
                                                            >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: "#f2f2f2" }}>
                                                                        {item.Action === "EDIT" && (
                                                                            <>
                                                                                <th className="audit-tableHeaderStyle">
                                                                                    Field
                                                                                </th>
                                                                                <th className="audit-tableHeaderStyle">
                                                                                    Before
                                                                                </th>
                                                                                <th className="audit-tableHeaderStyle">
                                                                                    After
                                                                                </th>
                                                                            </>
                                                                        )}
                                                                        {item.Action === "ADD" && (
                                                                            <th className="audit-tableHeaderStyle">Value</th>
                                                                        )}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {Array.isArray(item.JsonData) ? (
                                                                        item.JsonData.sort((a: JsonData, b: JsonData) =>
                                                                            a.field.localeCompare(b.field)
                                                                        ).map((dataItem: JsonData, dataIndex: number) => (
                                                                            <tr key={dataIndex}>
                                                                                <td className="audit-tableDataStyle">
                                                                                    {formatText(dataItem.field)}
                                                                                </td>
                                                                                {item.Action === "EDIT" && (
                                                                                    <>
                                                                                        <td className="audit-tableDataStyle">
                                                                                            {Array.isArray(dataItem.before)
                                                                                                ? dataItem.before.join(", ")
                                                                                                : (dataItem.before &&
                                                                                                    dataItem.before.value) ||
                                                                                                dataItem.before}
                                                                                        </td>
                                                                                        <td className="audit-tableDataStyle">
                                                                                            {dataItem.field === "Permission" &&
                                                                                                Array.isArray(dataItem.after) ? (
                                                                                                <table style={{ width: "100%" }}>
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th className="audit-tableHeaderStyle">
                                                                                                                Menu
                                                                                                            </th>
                                                                                                            <th className="audit-tableHeaderStyle">
                                                                                                                Actions
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody></tbody>
                                                                                                </table>
                                                                                            ) : Array.isArray(dataItem.after) ? (
                                                                                                dataItem.after.join(", ")
                                                                                            ) : (
                                                                                                (dataItem.after &&
                                                                                                    dataItem.after.value) ||
                                                                                                dataItem.after
                                                                                            )}
                                                                                        </td>
                                                                                    </>
                                                                                )}
                                                                                {item.Action === "ADD" && (
                                                                                    <td className="audit-tableDataStyle">
                                                                                        {dataItem.field === "Password" ||
                                                                                            dataItem.field === "Pin"
                                                                                            ? "******"
                                                                                            : dataItem.field === "Permission" &&
                                                                                                Array.isArray(dataItem.value) ? (
                                                                                                <table style={{ width: "100%" }}>
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th className="audit-tableHeaderStyle">
                                                                                                                Menu
                                                                                                            </th>
                                                                                                            <th className="audit-tableHeaderStyle">
                                                                                                                Actions
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody></tbody>
                                                                                                </table>
                                                                                            ) : Array.isArray(dataItem.value) ? (
                                                                                                dataItem.value.join(", ")
                                                                                            ) : (
                                                                                                (dataItem.value &&
                                                                                                    dataItem.value.value) ||
                                                                                                dataItem.value
                                                                                            )}
                                                                                    </td>
                                                                                )}
                                                                            </tr>
                                                                        ))
                                                                    ) : item.Action === "bulk_upload" &&
                                                                        item.JsonData &&
                                                                        typeof item.JsonData === "object" ? (
                                                                        (() => {
                                                                            const tableHeaderStyle: React.CSSProperties = {
                                                                                backgroundColor: "#e9ecef",
                                                                                fontWeight: "bold",
                                                                                padding: "6px",
                                                                                textAlign: "center",
                                                                            };
                                                                            const tableDataStyleA: React.CSSProperties = {
                                                                                padding: "6px",
                                                                                verticalAlign: "middle",
                                                                                textAlign: "center",
                                                                            };

                                                                            const entries = Object.entries(item.JsonData).sort(([keyA], [keyB]) => {
                                                                                const rankA = getAuditFieldRank(keyA);
                                                                                const rankB = getAuditFieldRank(keyB);
                                                                                return rankA - rankB;
                                                                            });

                                                                            return (
                                                                                <Table bordered size="sm">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            {entries.map(([key]) => (
                                                                                                <th key={key} style={tableHeaderStyle}>
                                                                                                    {formatText(key)}
                                                                                                </th>
                                                                                            ))}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            {entries.map(([key, value], idx) => (
                                                                                                <td key={key + idx} style={tableDataStyleA}>
                                                                                                    {String(formatText(value))}
                                                                                                </td>
                                                                                            ))}
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </Table>
                                                                            );
                                                                        })()
                                                                    ) : (

                                                                        <tr>
                                                                            <td colSpan={3} className="audit-tableDataStyle">
                                                                                {typeof item.JsonData === "object"
                                                                                    ? JSON.stringify(formatText(item.JsonData), null, 2)
                                                                                    : String(formatText(item.JsonData) || "")}
                                                                            </td>
                                                                        </tr>
                                                                    )}


                                                                </tbody>
                                                            </table>
                                                        )}
                                                    </td>
                                                    <td className="audit-tableDataStyle">{formatText(item.UserName)}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div>
                                    <center>No data available</center>
                                </div>
                            )}
                        </div>
                    </ModalBody>
                </Modal>
                {regenrateLoading && (
                    <div >
                        <div className="loading-overlay">
                            <div id="page">
                                <div id="container">
                                    <div id="ring"></div>
                                    <div id="ring"></div>
                                    <div id="ring"></div>
                                    <div id="ring"></div>
                                    <div id="h3" style={{ color: "black" }}>Regenrating...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default Bulkupload;
